<template>
  <!-- 实时音频录制页面主容器 -->
  <div class="realtimeaudio">

    <!-- 录音和笔记主容器 -->
    <div class="recode_notesbox">
      <!-- 左侧录音区域 -->
      <div class="recordlecture" ref="recordlecture">
        <!-- 笔记标题编辑区域 -->
        <div class="title-editor">
          <!-- 标题显示模式 -->
          <div v-if="!isEditingTitle" class="title-display">
            <h1>
              <!-- <img :src="record_icon" alt=""> -->
              <span>{{ noteTitle }}</span>
              <!-- 编辑按钮 -->
              <i class="el-icon-edit" @click="startEditTitle"></i>
            </h1>
          </div>
          <!-- 标题编辑模式 -->
          <div v-else class="title-input">
            <input v-model="noteTitle" placeholder="输入笔记标题" ref="titleInput" @keyup.enter="endEditTitle">
            <!-- 确认按钮 -->
            <i class="el-icon-check" @click="endEditTitle"></i>
          </div>
        </div>

        <!-- 未开始录音状态 -->
        <div class="notradio" v-show="radiostatus == 'notradio'">
          <!-- 录音开始按钮 -->
          <div @click="startRecording" class="yuan_btn record-button1" :class="{ 'connecting': isConnecting }">
            <i v-if="!isConnecting" class="el-icon-microphone"></i>
            <i v-else class="el-icon-loading connecting-icon"></i>
          </div>

          <!-- 连接状态提示 -->
          <div v-if="isConnecting" class="connection-status">
            <div class="status-text">{{ connectionStatusText }}</div>
            <div class="status-progress">
              <div class="progress-bar" :style="{ width: connectionProgress + '%' }"></div>
            </div>
          </div>

          <!-- 录音设置区域 -->
          <div class="recordin">
            <!-- 录音语言选择 -->
            <div class="select-group">
              <label class="right-label"><img :src="record_icon_l" alt="">Record in：</label>
              <el-select :disabled="elapsedTime > 0" v-model="appkey" class="selecttool" placeholder="Select">
                <el-option v-for="item in appkeyarr" :key="item.value" :label="item.name" :value="item">
                </el-option>
              </el-select>
            </div>

            <!-- 笔记语言选择 -->
            <div class="select-group">
              <label><img :src="record_icon_r" alt="">Note Language：</label>
              <el-select v-model="languagesItem" class="selecttool" placeholder="Select">
                <el-option v-for="item in languages" :key="item.code" :label="item.name" :value="item">
                </el-option>
              </el-select>
            </div>

            <!-- 在线课程模式开关 -->
            <div class="select-group">
              <label><i class="el-icon-headset"></i>Online-course Mode：</label>
              <label class="switch selecttool">
                <input type="checkbox" v-model="isSystemAudio">
                <span class="slider round"></span>
              </label>
            </div>

            <!-- 系统内录音提示 - 只在系统内录音模式下显示 -->
            <transition name="fade">
              <div class="system-audio-tip-container" v-if="isSystemAudio">
                <div class="system-audio-tip-inline"
                  :class="{ 'error': invalidCaptureType, 'warning': isBrowserIncompatible }">
                  <div class="tip-icon">
                    <i
                      :class="invalidCaptureType || isBrowserIncompatible ? 'el-icon-warning' : 'el-icon-info-circle'"></i>
                  </div>
                  <div class="tip-content">
                    <h3 v-if="isBrowserIncompatible">{{ getSystemAudioTipTitle }}</h3>
                    <p>{{ systemAudioTipText }}</p>
                    <!-- 浏览器推荐提示 -->
                    <div v-if="isBrowserIncompatible" class="browser-recommendation">
                      <span>Recommended Browser:</span>
                      <div class="browser-icons">
                        <div class="browser-icon" @click="openBrowserRecommendation">
                          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/chrome/chrome-original.svg"
                            alt="Chrome" />
                          <span>Chrome</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <!-- 系统内录音错误提示 - 仅在录音时显示 -->
        <transition name="fade">
          <div class="tip-container" v-if="showSystemAudioTip && radiostatus != 'notradio'">
            <div class="system-audio-tip" :class="{ 'error': invalidCaptureType, 'warning': isBrowserIncompatible }">
              <div class="tip-icon">
                <i :class="invalidCaptureType || isBrowserIncompatible ? 'el-icon-warning' : 'el-icon-info-circle'"></i>
              </div>
              <div class="tip-content">
                <p>{{ systemAudioTipText }}</p>
              </div>
              <div class="tip-close" @click="showSystemAudioTip = false">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </transition>

        <!-- 录音进行中状态 -->
        <div class="r-startradio" v-show="radiostatus == 'startradio'">
          <!-- 重连状态提示 -->
          <div v-if="isConnecting && isPaused" class="reconnection-status">
            <div class="status-icon">
              <i class="el-icon-loading"></i>
            </div>
            <div class="status-text">
              <span>{{ connectionStatusText }}</span>
              <div class="progress-bar">
                <div class="progress-fill" :style="{ width: connectionProgress + '%' }"></div>
              </div>
            </div>
          </div>

          <!-- 音频波形显示 -->
          <div class="waveform">
            <canvas ref="waveformCanvas" width="400" height="30"></canvas>
          </div>
          <!-- 录音时间显示 -->
          <div class="timer">{{ formattedTime }}</div>
          <!-- 录音控制按钮 -->
          <div class="controls">

            <!-- 暂停/继续录音按钮 -->
            <div @click="toggleRecording()" class="yuan_btn record-button">
              <i v-if="isRecording" class="el-icon-video-pause"></i>
              <i v-else-if="isConnecting" class="el-icon-loading"> </i>
              <i v-else class="el-icon-microphone record-button-microphone"></i>
            </div>
            <!-- 停止录音按钮 -->
            <div @click="stopRecording" class="yuan_btn stop-button" :disabled="!audioUrl">
              <i></i>
            </div>

            <!-- 翻译开关和语言选择 -->
            <div class="translate-control">
              <!-- 翻译开关 -->
              <div class="translate-switch-container">
                <label class="translate-switch">
                  <input type="checkbox" v-model="enableTranslation" @change="onTranslationToggle">
                  <span class="slider round"></span>
                </label>

                <!-- 翻译语言选择 -->
                <el-select v-if="enableTranslation" v-model="selectedLanguage" placeholder="Translate to" size="small"
                  class="language-select" :disabled="!enableTranslation">
                  <el-option v-for="lang in filteredTlanguages" :key="lang.code" :label="lang.fullname"
                    :value="lang.name">
                    <span class="language-flag" style="margin-right: 12px;">{{ lang.emoji }}</span>
                    <span class="language-name">{{ lang.fullname }}</span>
                  </el-option>
                </el-select>
                <span class="switch-label" v-else>Translation</span>
              </div>


            </div>
          </div>
        </div>

        <!-- 录音完成状态 -->
        <div class="r-stopradio" v-show="radiostatus == 'stopradio'">
          <!-- 音频播放器和波形显示 -->
          <div class="waveform">
            <canvas ref="waveformCanvas_R" width="300" height="40"></canvas>
            <audio ref="audioPlayer" :src="audioUrl" @timeupdate="onTimeUpdate" @ended="onAudioEnded"></audio>
          </div>

          <!-- 播放控制按钮 -->
          <div class="controls">
            <!-- 播放时间显示 -->
            <div class="timer">
              <span>{{ formatTime(currentTime) }} / {{ formatTime(elapsedTime) }}</span>
            </div>
            <!-- 播放/暂停按钮 -->
            <div @click="togglePlay()" class="record-button">
              <i v-if="!isPlaying" class="el-icon-video-play"></i>
              <i v-else class="el-icon-video-pause"></i>
            </div>
            <!-- 本地保存按钮 -->
            <el-button @click="downloadAudio" class="clear-button download-button"
              :disabled="!audioUrl || uploadstatus == 'uploading'">
              Save audio locally
            </el-button>
          </div>
        </div>

        <!-- 实时转录文本显示区域 -->
        <div class="alltextbox" ref="alltextbox" @scroll="handleScroll">

          <!-- 已完成的转录文本 -->
          <div class="textbox" :ref="textobj.text_id" v-for="(textobj, i) in textobjs" :key="i"
            :class="{ 'preview-merge': textobj.preview_merge }">
            <h5>{{ textobj.time }}</h5>
            <div class="yuantext">
              <!-- 如果有预览合并文本，显示预览文本，否则显示原文本 -->
              <span v-if="textobj.preview_merge && textobj.preview_text">
                {{ textobj.preview_text }}
              </span>
              <span v-else>{{ textobj.text }}</span>
              <!-- 合并次数标识 正式环境不要 -->
              <span v-if="false && textobj.merged_count && textobj.merged_count > 1" class="merge-count">
                ({{ textobj.merged_count }} 段合并)
              </span>
            </div>
            <!-- 翻译渲染区域 - 优化版本 -->
            <div class="translate-container" v-if="shouldShowTranslation(textobj)">
              <!-- 翻译中状态 -->
              <div v-if="textobj.translating" class="translate-loading">
                <div class="loading-spinner"></div>
                <span class="loading-text">Translating...</span>
              </div>

              <!-- 翻译完成状态 -->
              <div v-else-if="textobj.trans && !textobj.translationError" class="translatetext">
                {{ textobj.trans }}
              </div>

              <!-- 翻译错误状态 -->
              <div v-else-if="textobj.translationError" class="translate-error">
                <i class="el-icon-warning"></i>
                <span>Translation failed, please try again</span>
                <button @click="retryTranslation(textobj)" class="retry-btn">Retry</button>
              </div>
            </div>
          </div>
          <!-- 正在进行的转录文本 -->
          <div v-if="streamobj.stream_text && !shouldPreviewMerge" class="textbox">
            <h5>{{ streamobj.stream_time }}</h5>
            <div class="yuantext">{{ streamobj.stream_text }}</div>
            <div class="translatetext"> {{ streamobj.stream_trans }}</div>
          </div>


        </div>
        <div class="toscollbtn" v-if="!alltextboxScroll && textobjs.length > 0" @click="scrollToBottom">
          <i class="el-icon-bottom"></i>
        </div>
      </div>

      <!-- 分隔条 - 用于调整左右面板大小 -->
      <div class="resizer" ref="resizer"></div>

      <!-- 右侧笔记显示区域 -->
      <div class="recordtotext" ref="recordtotext">
        <!-- 笔记标题区域 -->
        <div class="titlebox">
          <!-- 笔记标题 -->
          <h1>
            <span> Live Notes:</span>
          </h1>

          <!-- 额外直播讲座按钮 -->
          <div class="extra" v-if="mtype > 0">
            <button @click="addExtra" class="extra-button" :disabled="radiostatus !== 'notradio'">
              <i class="el-icon-plus"></i>
              Extra Live Lecture
            </button>
          </div>
        </div>

        <!-- 生成的笔记显示区域 -->
        <div class="allnotesbox" ref="allnotesbox">
          <!-- 每个笔记段落 -->
          <div class="notesbox" v-for="(partobj, i) in partobjs" :key="i">
            <h5>{{ partobj.time }}</h5>
            <!-- 已生成的笔记内容 -->
            <div class="yuantext markdown-content" v-if="partobj.notes" v-html="partobj.notes"></div>
            <!-- 笔记生成中的加载状态 -->
            <div class="yuantext markdown-content" v-else>
              <div class="loading_img_box">
                <img :src="loading_img" alt="">
                <span>We are generating notes...</span>
              </div>
            </div>
          </div>

          <!-- 无笔记时的提示文本 -->
          <div class="tipstextbox" v-if="partobjs.length == 0">
            <p>Just a sec... Your notes are almost ready. 😊😊😊</p>
            <p>Make sure the recording is longer than 1 minute.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗组件 -->
    <!-- 录音保存弹窗 -->
    <popuprecordsave ref="pRecordsave" :percentage="uploadProgress" @saveaudio="saveaudio" />
    <!-- 离开页面保存提示弹窗 -->
    <popupchaoxian ref="leaveSave" :textcontent="leaveSavetext" :tonextname="leave_tonext" @saveaudio="saveaudio"
      @cancel="cancelSave" />
    <!-- 保存失败弹窗 -->
    <PopupSaveFailed ref="saveFailedPopup" @retry="handleRetryUpload" @close="handleCloseFailedPopup" />
    <!-- 额外功能弹窗 -->
    <popup_extra ref="extraPopup" />
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import IndexedDBAudioStorage from "@/assets/js/indexedDB.js";
import popuprecordsave from "@/views/pages/home_page/popups/popup_record_save.vue";
import popupchaoxian from "@/views/pages/home_page/popups/popup_record_leave.vue";
import PopupSaveFailed from '@/views/pages/home_page/popups/popup_save_failed.vue'
import popup_extra from "@/views/pages/home_page/popups/popup_extra.vue";
import {
  TipHelper,
} from "@/utils/browserTips.js";
import { logger } from '@/utils/logger.js';

export default {
  components: {
    popuprecordsave,
    popupchaoxian,
    PopupSaveFailed,
    popup_extra,
  },
  props: {
    uploadstatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 配置常量 - 优化连接参数
      CONFIG: {
        KEEP_ALIVE_INTERVAL: 60000, // 心跳间隔增加到60秒
        WEBSOCKET: {
          MAX_SENTENCE_SILENCE: 800,
          CONNECTION_TIMEOUT: 30000, // 连接超时增加到30秒
          MAX_RECONNECT_ATTEMPTS: 3, // 最大重连次数
          RECONNECT_BACKOFF_BASE: 2000, // 重连基础延迟改为2秒
          RECONNECT_BACKOFF_MAX: 30000, // 最大重连延迟
          HEARTBEAT_FAIL_THRESHOLD: 3, // 心跳失败阈值
          NETWORK_CHANGE_DEBOUNCE: 2000 // 网络状态变化防抖时间
        },
        TEXT_FRAGMENT: {
          MIN_LENGTH: 300,
          OPTIMAL_LENGTH: 500,
          MAX_MERGE_COUNT: 20,
          MERGE_SEPARATOR: ''
        }
      },

      shouldPreviewMerge: false, // 是否应该预览合并

      // 系统内录音相关属性
      isSystemAudio: false, // 是否启用系统内录音模式
      audioProcessor: null, // 音频处理器
      // 系统内录音提示相关
      showSystemAudioTip: false, // 是否显示系统录音提示
      systemAudioTipText: "Captures audio directly from a browser tab — ideal for online classes or web meetings.", // 系统录音提示文本
      invalidCaptureType: false, // 是否为无效的捕获类型
      isBrowserIncompatible: false, // 浏览器是否不兼容

      // 图标资源
      record_icon_l: require("@/assets/images/home/icon_live_l.png"), // 左侧录音图标
      record_icon_r: require("@/assets/images/home/icon_live_r.png"), // 右侧录音图标
      loading_img: require("@/assets/images/noteindex/loading_img1.gif"), // 加载动画图片
      record_icon: require("@/assets/images/home/record_icon.png"), // 录音图标

      // 录音状态控制
      radiostatus: "startradio", // 录音状态: notradio(未开始) startradio(录音中) stopradio(录音完成)
      isRecording: false, // 是否正在录音
      isPaused: false, // 是否暂停录音
      isProcessingShareEnd: false, // 是否正在处理共享结束事件，防止重复处理

      // 媒体相关对象
      stream: null, // 媒体流对象
      mediaRecorder: null, // 媒体录制器
      audioUrl: null, // 录音文件URL

      // 时间控制
      startTime: 0, // 录音开始时间戳
      elapsedTime: 0, // 已录制时间(秒)
      pauseTime: 0, // 暂停时间戳
      timer: null, // 计时器

      // 音频分析相关
      audioContext: null, // 音频上下文
      analyser: null, // 音频分析器
      dataArray: null, // 音频数据数组
      canvasContext: null, // Canvas绘图上下文
      animationFrame: null, // 动画帧ID

      // 音频播放相关
      isPlaying: false, // 是否正在播放
      currentTime: 0, // 当前播放时间
      playbackAnalyser: null, // 播放分析器
      playbackDataArray: null, // 播放数据数组
      playbackAnimationFrame: null, // 播放动画帧ID
      playaudioContext: null, // 播放音频上下文
      audioSource: null, // 音频源节点

      // 转录文本数据
      textobjs: [
      ], // 已完成的转录文本数组
      streamobj: { stream_time: "", stream_text: "", stream_trans: "" }, // 实时转录对象

      // 笔记生成相关
      partobjs: [], // 笔记段落数组
      partobj: { // 当前笔记段落对象
        text: "", // 文本内容 - 准备生成笔记，拼接成的段落
        time: "", // 时间
        trans: "", // 翻译
        notes: "", // 段落生成的笔记
        text_ids: [], // 文本id- 组成段落的文本ID
        partobj_id: "", // 笔记id
        timelength: 0, // 时间长度(秒)
      },

      noteid: -1, // 笔记ID

      // Markdown渲染器
      md: new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        highlight: function (str, lang) {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return hljs.highlight(lang, str).value;
            } catch (__) {
              logger.log("error", str, lang);
            }
          }
          return ""; // 使用默认的转义
        },
      }),

      show_trans: false, // 是否显示翻译
      selectedLanguage: '',
      enableTranslation: false, // 翻译开关状态
      Tlanguages: [
        { code: "EN", name: "English", fullname: "English", emoji: "🇬🇧" },
        { code: "ZH", name: "Chinese", fullname: "简体中文", emoji: "🇨🇳" },
        { code: "ZH(T)", name: "Traditional Chinese (Hong Kong)", fullname: "繁体中文", emoji: "🇭🇰" },
        { code: "ES", name: "Spanish", fullname: "Español", emoji: "🇪🇸" },
        { code: "FR", name: "French", fullname: "Français", emoji: "🇫🇷" },
        { code: "DE", name: "German", fullname: "Deutsch", emoji: "🇩🇪" },
        { code: "IT", name: "Italian", fullname: "Italiano", emoji: "🇮🇹" },
        { code: "JA", name: "Japanese", fullname: "日本語", emoji: "🇯🇵" },
        { code: "RU", name: "Russian", fullname: "Русский", emoji: "🇷🇺" },
        { code: "AR", name: "Arabic", fullname: "العربية", emoji: "🇸🇦" },
        { code: "HI", name: "Hindi", fullname: "हिन्दी", emoji: "🇮🇳" },
        { code: "PT", name: "Portuguese", fullname: "Português", emoji: "🇵🇹" },
        { code: "NL", name: "Dutch", fullname: "Nederlands", emoji: "🇳🇱" },
        { code: "KO", name: "Korean", fullname: "한국어", emoji: "🇰🇷" },
        { code: "TR", name: "Turkish", fullname: "Türkçe", emoji: "🇹🇷" },
      ],

      scriptProcessor: null, // 音频处理脚本
      // 语言配置
      languages: [ // 笔记语言选项
        { code: "EN", name: "English", value: "1", },
        { code: "ZH", name: "简体中文", value: "2" },
        { code: "ZH(T)", name: "繁体中文", value: "3" },
        { code: "ES", name: "Spanish", value: "4" },
        { code: "FR", name: "French", value: "5" },
        { code: "DE", name: "German", value: "6" },
        { code: "IT", name: "Italian", value: "7" },
        { code: "JA", name: "Japanese", value: "8" },
        { code: "RU", name: "Russian", value: "9" },
        { code: "AR", name: "Arabic", value: "10" },
        { code: "HI", name: "Hindi", value: "11" },
        { code: "PT", name: "Portuguese", value: "12" },
        { code: "NL", name: "Dutch", value: "13" },
        { code: "KO", name: "Korean", value: "14" },
        { code: "TR", name: "Turkish", value: "15" }
      ],
      languagesItem: {}, // 选中的笔记语言

      // 录音语言配置
      appkeyarr: [ // 录音语言选项
        { code: "en", name: "English", zhName: "英语", value: "3G3o7AlY1ncgnW8b" },
        { code: "zh", name: "中文", zhName: "中文", value: "zEURyO5izWCp17u9" },
        { code: "yue", name: "粤语", zhName: "粤语", value: "kV0JzwGpXHxGjMk6" },
        { code: "ru", name: "Russian", zhName: "俄语", value: "MdjmRjtynQQzfLmr" },
        { code: "ja", name: "Japanese", zhName: "日语", value: "03OLyZgpZdSbw2o2" },
        { code: "ko", name: "Korean", zhName: "韩语", value: "Qr672JcoALV09g5H" },
        { code: "de", name: "German", zhName: "德语", value: "XGBANgEKxxTEGSkR" },
        { code: "es", name: "Spanish", zhName: "西班牙语", value: "mf07QEy4zMvKNiCA" },
        { code: "fr", name: "French", zhName: "法语", value: "5WE4hnc6dzWI5o2C" },
        { code: "it", name: "Italian", zhName: "意大利语", value: "zhbOHHj9I3ejSOWk" },
        { code: "ar", name: "Arabic", zhName: "阿拉伯语", value: "40KHVNDUGFQw47E1" },
        { code: "hi", name: "Hindi", zhName: "印度", value: "c7Gb2aadvsMjhqkn" },
        { code: "pt", name: "Portuguese", zhName: "葡萄牙语", value: "Q1OQu8IdrxVTleWI" },
        { code: "nl", name: "Dutch", zhName: "荷兰语", value: "NF9tLDmn7t9Yz1Ro" },
        { code: "tr", name: "Turkish", zhName: "土耳其语", value: "mVMK8FtiDkohE4xw" },
      ],
      appkey: {}, // 选中的录音语言

      // WebSocket配置
      maxSentenceSilence: this.CONFIG?.WEBSOCKET?.MAX_SENTENCE_SILENCE?.toString() || '2000', // 断句间隔时间
      isyuyiduanju: false, // 是否启用语义断句
      zhandianobj: [{ // 服务器站点选项
        value: 'nls-gateway-singapore.aliyuncs.com',
        label: '新加坡'
      }, {
        value: 'nls-gateway.cn-shanghai.aliyuncs.com',
        label: '上海'
      }],
      zhandianurl: 'nls-gateway-singapore.aliyuncs.com', // 选中的服务器站点
      realtimetoken: '', // 实时转录Token

      // WebSocket连接状态
      websocket: null, // WebSocket连接对象
      taskId: null, // 任务ID
      messageId: null, // 消息ID
      startTranscriptiondata: null, // 开始转录的数据
      // 音频数据处理
      chunks: [], // 音频数据块数组
      chunkCounter: 0, // 数据块计数器
      maxrecordtime: 60, // 最大录音时间(分钟)

      keepAliveInterval: null, // 保活定时器
      lastActiveTime: 0, // 最后活跃时间

      // 语言选择
      chooeseLanguage: "", // 选择的语言代码
      chooeseLanguageName: "", // 选择的语言名称
      // 提示文本
      leaveSavetext: "Leaving this page will lose the unsaved audio. <br>Do you want to save the audio file locally?",
      leave_tonext: "", // 离开页面后的跳转目标

      // 用户类型和状态
      mtype: 0, // 用户类型
      outlanjie: false, // 是否为外部链接模式
      uploadProgress: 0, // 上传进度
      retryCount: 0, // 重试次数
      recordingState: 0, // 录音状态: 0(初始状态) 1(录音中) 2(录音已保存)

      // 笔记生成队列管理
      noteTaskQueue: [], // 笔记生成任务队列
      failedTasks: [], // 失败任务队列
      queueTimer: null, // 队列处理定时器
      retryTimer: null, // 失败任务重试定时器
      isProcessingQueue: false, // 是否正在处理队列
      // 网络状态
      isOnline: navigator.onLine, // 网络连接状态

      // 连接管理 - 优化连接状态管理
      reconnectTimer: null,
      checkConnectionTimer: null,
      connectionTimer: null,
      connectionRetryCount: 0,
      maxConnectionRetries: 3, // 减少最大重连次数
      connectionStatusText: "",
      connectionProgress: 0,
      isConnecting: false,
      isConnected: false,

      // 新增：连接质量管理
      connectionQuality: {
        heartbeatFailCount: 0, // 心跳失败次数
        lastHeartbeatTime: 0, // 最后心跳时间
        reconnectAttempts: 0, // 当前重连尝试次数
        lastReconnectTime: 0, // 最后重连时间
        networkChangeDebounceTimer: null // 网络变化防抖定时器
      },

      // 防抖变量
      startRecordingTimeout: null, // 开始录音的防抖定时器
      lastClickTime: 0, // 最后点击时间
      clickDebounceDelay: 500, // 防抖延迟500毫秒

      // 标题编辑
      isEditingTitle: false, // 是否正在编辑标题
      noteTitle: "", // 笔记标题

      // 实时文本处理优化
      streamTextTimer: null, // 流式文本更新定时器
      // 添加新的状态标记
      willStopRecordingSoon: false, // 标记是否即将停止录音
      lastAddedPartObjId: null, // 记录最后添加的partobj_id，防止重复
      isHandlingSystemRecordingEnd: false, // 标记是否正在处理系统录音结束
      lastAddTaskTime: 0, // 记录最后添加任务的时间戳

      scheduleReconnect_status: false, // 重连状态

      alltextboxScroll: false, // 是否滚动到底部

      translationPolling: null, // 轮询对象
      translation_text_ids: [], // 翻译文本ID
      last_textobjs_length: 0, // 记录上一次文本长度
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.elapsedTime / 60);
      const seconds = this.elapsedTime % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    loadingText() {
      return `Uploading... ${this.uploadProgress}%`;
    },
    islangtime() {
      return this.elapsedTime > 60 * this.maxrecordtime;
    },
    // 添加缺失的计算属性
    getSystemAudioTipTitle() {
      if (this.invalidCaptureType) {
        return 'Browser Tab Only';
      } else if (this.isBrowserIncompatible) {
        return 'Browser Not Compatible';
      } else {
        return 'Recording Tip';
      }
    },
    // 过滤翻译语言列表，排除与录音语言相同的语言
    filteredTlanguages() {
      if (!this.appkey || !this.appkey.code) {
        // 如果没有选择录音语言，只过滤掉'auto'
        return this.Tlanguages.filter(lang => lang.code !== 'auto');
      }

      // 创建录音语言代码到翻译语言代码的映射
      const recordToTranslateMap = {
        'en': 'EN',
        'zh': 'ZH',
        'yue': 'ZH(T)', // 粤语映射到繁体中文
        'ru': 'RU',
        'ja': 'JA',
        'ko': 'KO',
        'de': 'DE',
        'es': 'ES',
        'fr': 'FR',
        'it': 'IT',
        'ar': 'AR',
        'hi': 'HI',
        'pt': 'PT',
        'nl': 'NL',
        'tr': 'TR'
      };

      const recordLanguageCode = this.appkey.code.toLowerCase();
      const excludeTranslateCode = recordToTranslateMap[recordLanguageCode];

      // 过滤掉与录音语言相同的翻译语言和'auto'代码
      return this.Tlanguages.filter(lang =>
        lang.code !== excludeTranslateCode && lang.code !== 'auto'
      );
    }
  },
  mounted() {

    this.canvasContext = this.$refs.waveformCanvas.getContext("2d");
    this.mtype = this.$cookies.get("m_tkn", 0);
    if (this.mtype == 0) {
      this.maxrecordtime = 15;
    } else {
      this.maxrecordtime = 180;
    }

    // 进页面清理cookie中的录音状态标记
    this.$cookies.set('ischilddeep', '');

    // 清理 IndexedDB 中的旧录音数据，确保每次进入都是全新的录音环境
    this.clearStoredAudioData();

    // this.fetchLiveMinutes();
    this.fetchKey();
    this.initTaskTimers();
    this.$nextTick(() => {
      this.initResizer();
    });
    this.generateDefaultTitle();
    // 添加网络状态监听
    window.addEventListener('online', this.handleNetworkChange);
    window.addEventListener('offline', this.handleNetworkChange);
  },
  watch: {
    textobjs: {
      handler() {
        if (this.alltextboxScroll) {
          this.scrollToBottom();
        }
      },
      deep: true
    },
    streamobj: {
      handler() {
        if (this.alltextboxScroll) {
          this.scrollToBottom();
        }
      },
      deep: true
    },
    // 监听在线课程模式开关
    isSystemAudio: {
      handler(newVal) {
        if (newVal) {
          // 开启在线课程模式时检查浏览器兼容性
          this.checkBrowserCompatibility();
        } else {
          // 关闭在线课程模式时重置提示状态
          this.showSystemAudioTip = false;
          this.isBrowserIncompatible = false;
          this.systemAudioTipText = "Captures audio directly from a browser tab — ideal for online classes or web meetings.";
        }
      },
      immediate: false
    },
    // 监听录音语言变化
    appkey: {
      handler(newVal) {
        if (!newVal || !newVal.code) return;

        // 创建录音语言代码到翻译语言代码的映射
        const recordToTranslateMap = {
          'en': 'EN',
          'zh': 'ZH',
          'yue': 'ZH(T)', // 粤语映射到繁体中文
          'ru': 'RU',
          'ja': 'JA',
          'ko': 'KO',
          'de': 'DE',
          'es': 'ES',
          'fr': 'FR',
          'it': 'IT',
          'ar': 'AR',
          'hi': 'HI',
          'pt': 'PT',
          'nl': 'NL',
          'tr': 'TR'
        };

        const recordLanguageCode = newVal.code.toLowerCase();
        const excludeTranslateCode = recordToTranslateMap[recordLanguageCode];

        // 如果当前选中的翻译语言与新的录音语言相同，则清空翻译语言选择
        if (this.selectedLanguage && excludeTranslateCode) {
          const currentTranslateLanguage = this.Tlanguages.find(lang => lang.name === this.selectedLanguage);
          if (currentTranslateLanguage && currentTranslateLanguage.code === excludeTranslateCode) {
            this.selectedLanguage = '';
          }
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 处理翻译开关状态变化
    onTranslationToggle() {
      if (!this.enableTranslation) {
        // 关闭翻译开关时清空选中的翻译语言
        this.selectedLanguage = '';
      }
    },

    handleScroll() {
      const el = this.$refs.alltextbox;
      const threshold = 10; // 允许误差（避免频繁触发）
      const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
      this.alltextboxScroll = isAtBottom; // 用户往上滑时取消自动滚动
    },
    /**
     * 统一的浏览器信息检测工具
     * @returns {Object} 浏览器信息对象
     */
    getBrowserInfo() {
      const userAgent = navigator.userAgent;
      const isChrome = /Chrome/.test(userAgent) && !/Edge|Edg/.test(userAgent);
      const isSafari = /Safari/.test(userAgent) && !/Chrome|Chromium/.test(userAgent);
      const isFirefox = /Firefox/.test(userAgent);
      const isEdge = /Edge|Edg/.test(userAgent);

      return {
        isChrome,
        isSafari,
        isFirefox,
        isEdge,
        userAgent,
        supportsSystemAudio: isChrome || isEdge,
        supportsWebRTC: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
      };
    },

    /**
     * 获取Safari版本号
     * @returns {number|null} Safari版本号或null
     */
    getSafariVersion() {
      const match = navigator.userAgent.match(/Version\/(\d+)/);
      return match ? parseInt(match[1]) : null;
    },

    /**
     * 统一的异步操作错误处理
     * @param {Function} operation - 要执行的异步操作
     * @param {string} operationName - 操作名称，用于错误提示
     * @returns {Promise} 操作结果
     */
    async handleAsyncOperation(operation, operationName = '操作') {
      try {
        return await operation();
      } catch (error) {
        logger.error(`[${operationName}] 执行失败:`, error);

        // 根据不同错误类型进行处理
        if (error.name === 'NotAllowedError') {
          this.$message.error('权限被拒绝，请检查浏览器设置');
        } else if (error.name === 'NotFoundError') {
          this.$message.error('未找到音频设备');
        } else if (error.name === 'InvalidStateError') {
          this.$message.error('音频设备状态异常，请刷新页面重试');
        } else {
          this.$message.error(`${operationName}失败，请重试`);
        }

        throw error;
      }
    },

    /**
     * 完善的资源清理机制
     */
    cleanupRecordingResources() {
      // 清理媒体流
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }

      // 清理MediaRecorder
      if (this.mediaRecorder) {
        if (this.mediaRecorder.state !== 'inactive') {
          this.mediaRecorder.stop();
        }
        this.mediaRecorder = null;
      }

      // 清理音频上下文
      if (this.audioContext && this.audioContext.state !== 'closed') {
        this.audioContext.close().catch(error =>
          logger.error('[清理] 关闭音频上下文失败:', error)
        );
        this.audioContext = null;
      }

      // 清理播放音频上下文
      if (this.playaudioContext && this.playaudioContext.state !== 'closed') {
        this.playaudioContext.close().catch(error =>
          logger.error('[清理] 关闭播放音频上下文失败:', error)
        );
        this.playaudioContext = null;
      }

      // 清理音频处理器
      if (this.audioProcessor) {
        this.audioProcessor.disconnect();
        this.audioProcessor = null;
      }

      if (this.scriptProcessor) {
        this.scriptProcessor.disconnect();
        this.scriptProcessor = null;
      }

      // 清理音频源节点
      if (this.audioSource) {
        this.audioSource.disconnect();
        this.audioSource = null;
      }

      // 清理分析器
      if (this.analyser) {
        this.analyser.disconnect();
        this.analyser = null;
      }

      if (this.playbackAnalyser) {
        this.playbackAnalyser.disconnect();
        this.playbackAnalyser = null;
      }
    },

    /**
     * 清理所有定时器
     */
    cleanupTimers() {
      const timers = [
        'timer', 'connectionTimer', 'reconnectTimer', 'checkConnectionTimer',
        'keepAliveInterval', 'queueTimer', 'retryTimer'
      ];

      timers.forEach(timerName => {
        if (this[timerName]) {
          if (timerName.includes('Interval')) {
            clearInterval(this[timerName]);
          } else {
            clearTimeout(this[timerName]);
          }
          this[timerName] = null;
        }
      });
    },

    /**
     * 清理动画帧
     */
    cleanupAnimationFrames() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
      if (this.playbackAnimationFrame) {
        cancelAnimationFrame(this.playbackAnimationFrame);
        this.playbackAnimationFrame = null;
      }
    },

    /**
     * 重置所有状态
     */
    resetAllStates() {
      this.isRecording = false;
      this.isPaused = false;
      this.isPlaying = false;
      this.isConnected = false;
      this.isConnecting = false;
      this.radiostatus = "notradio";
      this.recordingState = 0;
      this.elapsedTime = 0;
      this.currentTime = 0;
      this.startTime = 0;
      this.pauseTime = 0;
      this.audioUrl = null;
      this.showSystemAudioTip = false;
      this.invalidCaptureType = false;
      this.isBrowserIncompatible = false;
      this.isProcessingShareEnd = false;
    },

    /**
     * 添加额外的直播讲座
     * 打开额外功能弹窗
     */
    addExtra() {
      this.$refs.extraPopup.openModal('over_on');
    },

    /**
     * 清理存储的音频数据
     * 确保每次进入录音页面都有一个干净的环境
     */
    async clearStoredAudioData() {
      return this.handleAsyncOperation(async () => {
        logger.log("[初始化] 清理旧的录音数据");
        await IndexedDBAudioStorage.clearDB();
        logger.log("[初始化] 录音数据清理完成");

        // 重置相关状态
        this.audioChunks = [];
        this.chunks = [];
        this.chunkCounter = 0;
        this.systemAudioBuffers = [];
        this.lastSaveTime = 0;
        this.audioUrl = null;
        this.elapsedTime = 0;
        this.currentTime = 0;
        this.isPlaying = false;
        this.isPaused = false;
        this.radiostatus = "notradio";
        this.textobjs = [];
        this.streamobj = {
          stream_time: "",
          stream_text: "",
          stream_trans: ""
        };
      }, "清理录音数据");
    },

    /**
     * 上传文件到R2存储
     * @param {File} file - 要上传的文件
     * @returns {Promise} 上传结果
     */
    async uploadToR2(file) {
      try {
        const subid = this.$cookies.get('subid');
        // 1. 获取预签名URL
        const { data } = await this.$axios.post('/api/get_upload_url/', {
          fileName: file.name,
          fileType: file.type,
          subid: subid
        });

        if (!data.uploadUrl) {
          throw new Error('Failed to get upload URL');
        }
        // 2. 使用 XMLHttpRequest 上传文件以获取进度
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          // 监听上传进度
          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
              const percentComplete = Math.max(2, Math.floor((event.loaded / event.total) * 100));
              logger.log(`Upload progress: ${percentComplete}%`);
              // 更新上传进度
              if (percentComplete < 99) {
                this.uploadProgress = percentComplete;
              }
            }
          };
          // 上传完成
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve({
                success: true,
                fileKey: data.fileKey,
                url: data.uploadUrl.split('?')[0]
              });
            } else {
              reject(new Error(`Upload failed with status: ${xhr.status}`));
            }
          };

          // 上传错误
          xhr.onerror = () => {
            reject(new Error('Network error during upload'));
          };

          // 开始上传
          xhr.open('PUT', data.uploadUrl, true);
          xhr.setRequestHeader('Content-Type', file.type);
          xhr.send(file);
        });

      } catch (error) {
        logger.error('Upload failed:', error);
        this.$message.error(`Upload failed: ${error.message}`);
        throw error;
      }
    },

    /**
     * 离开页面时的保存处理
     * @param {string} tonext - 跳转目标
     * @returns {string} 返回跳转目标或空字符串
     */
    leaveSave(tonext) {
      if (this.elapsedTime > 10) {
        this.leave_tonext = tonext;
        this.$refs.leaveSave.openModal();
        return '';
      } else {
        return tonext;
      }
    },

    /**
     * 获取API密钥
     * 从服务器获取实时转录所需的Token
     */
    async fetchKey() {
      try {
        const response = await this.$axios.get('https://www.easynoteai.com/api/get_key');
        const data = response.data;
        this.realtimetoken = data.token;
      } catch (error) {
        logger.error('Error fetching key:', error);
      }
    },

    /**
     * 返回主页
     * 如果正在录音则显示保存提示，否则直接返回
     */
    backhomepage() {
      if (this.outlanjie) {
        this.$refs.leaveSave.openModal();
      } else {
        this.$emit("backhomepage");
      }
    },

    /**
     * 点击左侧提示保存
     * @param {string} key - 操作类型
     */
    clickleft_tipsave(key) {
      logger.log("clickleft_tipsave", key);
      if (this.recordingState === 1) { // 只在录音中状态触发弹窗
        this.$refs.leaveSave.openModal();
      }
    },

    /**
     * 切换音频播放状态
     * 播放或暂停录制完成的音频
     */
    togglePlay() {
      if (this.isPlaying) {
        this.$refs.audioPlayer.pause();
        cancelAnimationFrame(this.playbackAnimationFrame);
      } else {
        this.$refs.audioPlayer
          .play()
          .then(() => {
            this.setupPlaybackAnalyser();
            this.drawPlaybackWaveform();
          })
          .catch((error) => {
            logger.error("Error playing audio:", error);
          });
      }
      this.isPlaying = !this.isPlaying;
    },

    /**
     * 格式化时间显示
     * @param {number} time - 时间(秒)
     * @returns {string} 格式化后的时间字符串 MM:SS
     */
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },


    /**
     * 音频播放结束事件处理
     */
    onAudioEnded() {
      this.isPlaying = false;
      cancelAnimationFrame(this.playbackAnimationFrame);
    },

    /**
     * 音频播放时间更新事件处理
     * @param {Event} e - 时间更新事件
     */
    onTimeUpdate(e) {
      this.currentTime = e.target.currentTime;
    },

    /**
     * 切换录音状态
     * 开始录音、暂停录音或恢复录音
     */
    async toggleRecording() {
      const currentTime = Date.now();
      
      // 防抖机制：如果距离上次点击时间太短，忽略这次点击
      if (currentTime - this.lastClickTime < this.clickDebounceDelay) {
        logger.log("[切换录音] 防抖机制触发，忽略快速点击");
        return;
      }
      this.lastClickTime = currentTime;

      if (!this.isRecording && !this.isPaused) {
        logger.log('开始录音');
        await this.startRecording();
      } else if (this.isRecording && !this.isPaused) {
        logger.log('暂停录音');
        this.pauseRecording();
      } else if (this.isPaused) {
        // 打印时间 到毫秒
        logger.log('恢复录音' + new Date().getTime());
        this.resumeRecording();
      }
    },

    /**
     * 保存音频数据块到IndexedDB
     * @param {Blob} chunk - 音频数据块
     */
    async saveChunk(chunk) {
      try {
        await IndexedDBAudioStorage.saveChunk(chunk);
      } catch (error) {
        logger.error("Error saving chunk:", error);
      }
    },

    /**
     * 根据录音模式选择麦克风录音或系统内录音
     */
    async startRecording() {
      const currentTime = Date.now();
      
      // 防抖机制：如果距离上次点击时间太短，忽略这次点击
      if (currentTime - this.lastClickTime < this.clickDebounceDelay) {
        logger.log("[录音] 防抖机制触发，忽略快速点击");
        return;
      }
      this.lastClickTime = currentTime;

      // 清除之前的防抖定时器
      if (this.startRecordingTimeout) {
        clearTimeout(this.startRecordingTimeout);
        this.startRecordingTimeout = null;
      }

      // 防止重复点击：如果正在录音、正在连接或已经连接，则不允许重复执行
      if (this.isRecording || this.radiostatus === 'startradio') {
        logger.log("[录音] 防止重复点击，当前状态:", { 
          isRecording: this.isRecording, 
          radiostatus: this.radiostatus 
        });
        return;
      }

      if (!this.appkey || !this.appkey.value) {
        this.$message.error('Please select the Record language first.'); return;
      }
      if (!this.languagesItem || !this.languagesItem.name) {
        this.$message.error('Please select the Note language first.'); return;
      }
      
      try {
        // 检查是否已经连接
        await this.startConnectionProcess();

        if (this.isSystemAudio) {
          await this.startSystemAudioRecording();
        } else {
          await this.startMicrophoneRecording();
        }
      } catch (error) {
        logger.error("[录音] 启动错误:", error);
        // 显示友好的错误信息
        this.showSystemAudioTip = true;
        const cancelTip = TipHelper.getSystemAudioTip('USER_CANCELLED');
        this.systemAudioTipText = cancelTip.message;
        // 重置录音状态
        this.radiostatus = "notradio";
        this.isRecording = false;
        this.isPaused = false;
        this.isConnecting = false; // 重置连接状态
        // 删除可能存在的音频流
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }
      }
    },

    /**
     * 开始麦克风录音
     * 获取麦克风权限并开始录制音频
     */
    async startMicrophoneRecording() {
      // 如果当前状态不是startradio，则设置为startradio，并设置outlanjie为true，recordingState为1
      if (this.radiostatus != "startradio") {
        this.radiostatus = "startradio";
        this.outlanjie = true;
        this.recordingState = 1; // 设置为录音中状态
        // 设置cookie标记录音状态，用于左侧栏点击检测
        this.$cookies.set('ischilddeep', 'islive');
      }
      this.isRecording = true;
      try {
        // 获取麦克风权限
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        // 创建音频上下文和分析器
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)({ sampleRate: 16000 });
        this.audioSource = this.audioContext.createMediaStreamSource(this.stream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = 2048;
        this.audioSource.connect(this.analyser);
        this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

        // 创建媒体录制器
        this.mediaRecorder = new MediaRecorder(this.stream);
        this.mediaRecorder.addEventListener("dataavailable", async (event) => {
          // 如果有数据，则保存数据并增加chunkCounter
          if (event.data.size > 0) {
            await this.saveChunk(event.data);
            this.chunkCounter++;
          }
          // 如果islangtime为true，则打开vipchaoxian并停止录音
          if (this.islangtime) {
            this.openvipchaoxian();
            this.stopRecording();
          }
        });
        // 创建音频处理脚本，用于实时发送音频数据到WebSocket
        const scriptProcessor = this.audioContext.createScriptProcessor(2048, 1, 1)
        scriptProcessor.onaudioprocess = async (event) => {
          if (!this.isRecording) {
            return;
          }
          const inputData = event.inputBuffer.getChannelData(0);
          const inputData16 = new Int16Array(inputData.length);
          for (let i = 0; i < inputData.length; ++i) {
            inputData16[i] = Math.max(-1, Math.min(1, inputData[i])) * 0x7FFF;
          }

          // 优化的WebSocket发送逻辑
          if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
            try {
              this.websocket.send(inputData16.buffer);
              // 更新最后活跃时间
              this.lastActiveTime = Date.now();
            } catch (error) {
              logger.error('[音频发送] 发送失败:', error);
              // 不立即重连，让心跳机制处理连接问题
            }
          } else if (this.websocket && this.websocket.readyState === WebSocket.CONNECTING) {
            // 连接中，暂时跳过发送
          } else if (!this.isConnecting) {
            // 只有在未连接且不在连接过程中时才尝试重连
            this.scheduleReconnect();
          }


        };
        this.audioSource.connect(scriptProcessor);
        scriptProcessor.connect(this.audioContext.destination);

        // 设置录制器停止事件处理
        // 监听mediaRecorder的stop事件
        this.mediaRecorder.addEventListener("stop", async () => {
          // 如果正在录制且mediaRecorder的状态为inactive
          if (this.isRecording && this.mediaRecorder?.state === 'inactive') {
            // 重新开始录制
            this.mediaRecorder.start();
          } else {
            // 否则，结束录制
            await this.finalizeRecording();
          }
        });

        // 开始录制媒体流，每1000毫秒录制一次
        this.mediaRecorder.start(1000);
        
        this.isPaused = false;

        // 设置录音时间计算
        if (this.pauseTime != 0) {
          this.startTime += Date.now() - this.pauseTime;
          this.pauseTime = 0;
        } else {
          this.startTime = Date.now();
        }
        // 启动计时器
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
          if (this.islangtime) {
            this.openvipchaoxian();
            this.stopRecording();
          }
        }, 1000);

        // 开始绘制波形
        this.drawWaveform();

      } catch (err) {
        logger.error("Error accessing microphone:", err);
      }
    },

    openBrowserRecommendation() {
      window.open('https://www.google.com/chrome/', '_blank');
    },

    async startSystemAudioRecording() {
      // 重置错误状态
      this.showSystemAudioTip = false;
      this.systemAudioTipText = "";
      this.invalidCaptureType = false;

      if (this.radiostatus != "startradio") {
        this.radiostatus = "startradio";
        this.outlanjie = true;
        this.recordingState = 1; // 设置为录音中状态
        // 设置cookie标记录音状态，用于左侧栏点击检测
        this.$cookies.set('ischilddeep', 'islive');
      }
      this.isRecording = true;
      logger.log("[系统录音] 开始请求系统音频权限");
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) {
        this.showSystemAudioTip = true;
        this.isBrowserIncompatible = true;
        this.systemAudioTipText = 'Your browser does not support Web Audio API. Please use Chrome browser.';
        throw new Error('Browser does not support Web Audio API');
      }

      if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
        this.showSystemAudioTip = true;
        this.isBrowserIncompatible = true;
        this.systemAudioTipText = 'Your browser does not support screen sharing or system audio recording. Please use Chrome browser.';
        throw new Error('Browser does not support system audio recording');
      }

      try {
        // 创建音频上下文 - 使用与麦克风录音相同的采样率(16000)
        this.audioContext = new AudioContext({
          sampleRate: 16000
        });

        // 请求屏幕共享并包含音频
        try {
          this.stream = await navigator.mediaDevices.getDisplayMedia({
            video: {
              cursor: 'always'
            },
            audio: true
          });
        } catch (permissionError) {
          // 用户取消了屏幕共享选择
          if (permissionError.name === 'NotAllowedError') {
            logger.warn('[系统录音] 用户取消了屏幕共享请求');
            this.radiostatus = "notradio";
            this.recordingState = 0;
            this.isRecording = false;
            this.isPaused = false;
            this.outlanjie = false;
            // 重置连接状态
            this.isConnected = false;
            this.isConnecting = false;
            // 显示友好的错误提示
            this.showSystemAudioTip = true;
            const cancelTip = TipHelper.getSystemAudioTip('USER_CANCELLED');
            this.systemAudioTipText = cancelTip.message;
            // 关闭已创建的资源
            if (this.audioContext && this.audioContext.state !== 'closed') {
              await this.audioContext.close();
              this.audioContext = null;
            }

            throw permissionError; // 向上层传递错误
          }
          // 其他权限错误
          throw permissionError;
        }
        // 检查共享类型 - 只允许浏览器标签
        const videoTrack = this.stream.getVideoTracks()[0];
        if (videoTrack) {
          const settings = videoTrack.getSettings();
          logger.log('[系统录音] 屏幕共享类型:', settings.displaySurface);
          // 检查是否为浏览器标签
          if (settings.displaySurface && settings.displaySurface !== 'browser') {
            // 停止当前音视频流
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
            // 设置错误信息
            this.showSystemAudioTip = true;
            const invalidCaptureTip = TipHelper.getSystemAudioTip('INVALID_CAPTURE_TYPE');
            this.systemAudioTipText = invalidCaptureTip.message;
            this.invalidCaptureType = true;
            // 重置录音状态
            this.radiostatus = "notradio";
            this.recordingState = 0;
            this.isRecording = false;
            this.isPaused = false;
            this.outlanjie = false;
            // 重置连接状态
            this.isConnected = false;
            this.isConnecting = false;

            // 关闭音频上下文
            if (this.audioContext && this.audioContext.state !== 'closed') {
              await this.audioContext.close();
              this.audioContext = null;
            }
            throw new Error('只支持浏览器标签页录制');
          }
          // 设置视频轨道结束事件处理程序
          videoTrack.addEventListener('ended', async () => {
            logger.log('[系统录音] 屏幕共享已停止，自动执行保存音频和笔记');
            // 防止重复处理（音频轨道和视频轨道可能同时触发ended事件）
            if (this.isProcessingShareEnd) {
              logger.log('[系统录音] 共享结束事件正在处理中，跳过重复处理');
              return;
            }
            this.isProcessingShareEnd = true;

            try {
              // 使用统一的系统录音结束处理方法
              await this.handleSystemRecordingEnd('屏幕共享停止');
            } finally {
              // 重置处理标志，防止重复处理
              this.isProcessingShareEnd = false;
            }
          });
        }
        // 检查是否获取到音频轨道
        const audioTracks = this.stream.getAudioTracks();
        if (audioTracks.length === 0) {
          this.showSystemAudioTip = true;
          const noAudioTip = TipHelper.getSystemAudioTip('NO_AUDIO_TRACK');
          this.systemAudioTipText = noAudioTip.message;

          // 停止已获取的流
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
          // 重置录音状态
          this.radiostatus = "notradio";
          this.recordingState = 0;
          this.isRecording = false;
          this.isPaused = false;
          this.outlanjie = false;
          // 重置连接状态
          this.isConnected = false;
          this.isConnecting = false;
          // 关闭音频上下文
          if (this.audioContext && this.audioContext.state !== 'closed') {
            await this.audioContext.close();
            this.audioContext = null;
          }

          throw new Error('未检测到音频轨道');
        }
        logger.log('[系统录音] 成功获取系统音频轨道:', audioTracks[0].label);
        // 显示成功提示
        this.showSystemAudioTip = true;
        const successTip = TipHelper.getSystemAudioTip('SUCCESS');
        this.systemAudioTipText = successTip.message;

        // 创建音频节点
        this.audioSource = this.audioContext.createMediaStreamSource(this.stream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = 2048;
        this.audioSource.connect(this.analyser);
        this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

        // 创建音频处理流程 - 使用与麦克风录音相同的方式
        const outputStream = new MediaStream();
        const audioTrack = this.stream.getAudioTracks()[0];
        outputStream.addTrack(audioTrack);

        // 为音频轨道添加结束事件监听器
        audioTrack.addEventListener('ended', async () => {
          logger.log('[系统录音] 音频轨道已停止，自动执行保存音频和笔记');
          // 防止重复处理（音频轨道和视频轨道可能同时触发ended事件）
          if (this.isProcessingShareEnd) {
            logger.log('[系统录音] 共享结束事件正在处理中，跳过重复处理');
            return;
          }
          this.isProcessingShareEnd = true;
          try {
            // 使用统一的系统录音结束处理方法
            await this.handleSystemRecordingEnd('音频轨道停止');
          } finally {
            // 重置处理标志，防止重复处理
            this.isProcessingShareEnd = false;
          }
        });

        // 检查支持的MIME类型
        let mimeType = 'audio/webm';
        if (MediaRecorder.isTypeSupported) {
          if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
            mimeType = 'audio/webm;codecs=opus';
          } else if (MediaRecorder.isTypeSupported('audio/webm')) {
            mimeType = 'audio/webm';
          } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
            mimeType = 'audio/mp4';
          }
        }
        logger.log(`[系统录音] 使用MIME类型: ${mimeType}`);
        // 创建MediaRecorder
        try {
          this.mediaRecorder = new MediaRecorder(outputStream, { mimeType });
        } catch (error) {
          logger.error(`[系统录音] MediaRecorder创建失败，尝试使用默认配置: ${error.message}`);
          // 尝试使用默认配置创建
          this.mediaRecorder = new MediaRecorder(outputStream);
        }
        // 设置数据回调
        this.mediaRecorder.addEventListener("dataavailable", async (event) => {
          if (event.data.size > 0) {
            await this.saveChunk(event.data);
            this.chunkCounter++;
          }
          if (this.islangtime) {
            this.openvipchaoxian();
            this.stopRecording();
          }
        });

        // 设置停止回调
        this.mediaRecorder.addEventListener("stop", async () => {
          if (this.isRecording && this.mediaRecorder?.state === 'inactive') {
            this.mediaRecorder.start();
          } else {
            await this.finalizeRecording();
          }
        });

        // 创建WebSocket发送处理
        const scriptProcessor = this.audioContext.createScriptProcessor(2048, 1, 1);
        scriptProcessor.onaudioprocess = async (event) => {
          if (!this.isRecording) {
            return;
          }
          // 获取音频数据
          const inputData = event.inputBuffer.getChannelData(0);
          const inputData16 = new Int16Array(inputData.length);

          // 转换为16位整数
          for (let i = 0; i < inputData.length; ++i) {
            inputData16[i] = Math.max(-1, Math.min(1, inputData[i])) * 0x7FFF;
          }

          // 优化的WebSocket发送逻辑
          if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
            try {
              this.websocket.send(inputData16.buffer);
              // 更新最后活跃时间
              this.lastActiveTime = Date.now();
            } catch (error) {
              logger.error('[系统音频发送] 发送失败:', error);
              // 不立即重连，让心跳机制处理连接问题
            }
          } else if (this.websocket && this.websocket.readyState === WebSocket.CONNECTING) {
            // 连接中，暂时跳过发送
            logger.log('[系统音频发送] WebSocket连接中，跳过数据发送');
          } else if (!this.isConnecting) {
            // 只有在未连接且不在连接过程中时才尝试重连
            logger.log('[系统音频发送] WebSocket未连接，尝试重连...');
            this.scheduleReconnect();
          }
        };
        // 连接处理器
        this.audioSource.connect(scriptProcessor);
        scriptProcessor.connect(this.audioContext.destination);

        // 开始录音
        this.mediaRecorder.start(1000);
        this.isPaused = false;
        // 记录录音开始时间
        if (this.pauseTime != 0) {
          this.startTime += Date.now() - this.pauseTime;
          this.pauseTime = 0;
          logger.log(`[系统录音] 恢复录音: 开始时间=${this.startTime}`);
        } else {
          this.startTime = Date.now();
          logger.log(`[系统录音] 新录音: 开始时间=${this.startTime}`);
        }
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
          if (this.islangtime) {
            this.openvipchaoxian();
            this.stopRecording();
          }
        }, 1000);
        this.drawWaveform();
      } catch (error) {
        logger.error('[系统录音] 错误:', error);
        // 如果还没有设置提示，则设置一个通用错误提示
        if (!this.showSystemAudioTip) {
          this.showSystemAudioTip = true;
          this.systemAudioTipText = error.name === "NotAllowedError" ?
            "You denied screen sharing permission. System audio recording requires this permission to work." :
            'Failed to start system audio recording. Please refresh the page and try again.';
        }
        // 确保清理任何已创建的资源
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }
        if (this.audioContext && this.audioContext.state !== 'closed') {
          await this.audioContext.close().catch(e => logger.error('[系统录音] 关闭音频上下文错误:', e));
          this.audioContext = null;
        }
        // 重置UI状态
        this.radiostatus = "notradio";
        this.recordingState = 0;
        // 传递错误以便调用方处理
        throw error;
      }
    },

    async pauseRecording() {
      if (this.isRecording && !this.isPaused) {
        this.isPaused = true;
        this.isRecording = false;
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.pauseTime = Date.now();
        // 无论是哪种录音模式，都使用相同的MediaRecorder暂停方式
        if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
          logger.log(`[录音] 暂停MediaRecorder: 状态=${this.mediaRecorder.state}`);
          this.mediaRecorder.pause();
        }
        // 暂停音频上下文
        if (this.audioContext && this.audioContext.state === 'running') {
          this.audioContext.suspend().catch(error =>
            logger.error("[录音] 暂停音频上下文失败:", error)
          );
        }
        // 停止波形动画
        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }
        this.disconnectWebSocketGracefully();
      }
    },
    async resumeRecording() {
      if (this.isPaused) {
        // await this.startConnectionProcess();
        // 恢复MediaRecorder
        if (this.mediaRecorder && this.mediaRecorder.state === "paused") {
          logger.log(`[录音] 恢复MediaRecorder: 状态=${this.mediaRecorder.state}`);
          this.mediaRecorder.resume();
        } else {
          logger.log('[录音] 恢复MediaRecorder失败');
        }
        // 恢复音频上下文
        if (this.audioContext && this.audioContext.state === "suspended") {
          this.audioContext
            .resume()
            .then(async () => {
              await this.startConnectionProcess();
              this.drawWaveform();
            })
            .catch((error) =>
              logger.error("[录音] 恢复音频上下文失败:", error)
            );
        } else {
          logger.log('[录音] 恢复音频上下文失败');
        }

        this.isPaused = false;
        this.isRecording = true;
        this.startTime += Date.now() - this.pauseTime;
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
          if (this.islangtime) {
            this.openvipchaoxian();
            this.stopRecording();
          }
        }, 1000);
      }
    },

    generateUUID() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      ).replace(/-/g, '');
    },
    generateUUID8() {
      // 返回当前时间戳的整数部分，并截取或补零使其长度为八位
      const timestamp = Math.floor(Date.now() / 1000).toString();
      return timestamp;
    },
    // 连接WebSocket
    async startConnectionProcess() {
      try {
        // 防止重复点击
        logger.log('[连接] 防止重复点击', this.isConnecting);
        if (this.isConnecting) {
          return;
        }
        // 清理之前的连接
        await this.cleanupPreviousConnection();

        if (this.isBrowserIncompatible) {
          this.$message.error('Your browser does not support system audio recording. Please use Chrome browser.');
          return;
        }
        if (!this.zhandianurl) {
          this.$message.error('请选择站点'); return;
        }
        // 立即显示连接状态// 立即显示连接状态
        this.isConnecting = true;

        this.connectionStatusText = "Initializing...";
        this.connectionProgress = 10;
        this.connectionRetryCount = 0;

        // 更新状态
        this.connectionStatusText = "Preparing audio...";
        this.connectionProgress = 30;
        // 验证参数
        const mss_num = this.maxSentenceSilence * 1;
        if (!mss_num || mss_num < 200 || mss_num > 2000) {
          throw new Error('请输入合法断句的时长');
        }
        this.chooeselanguage(this.appkey.value, this.languagesItem.name);
        // 连接WebSocket
        this.connectionStatusText = "Connecting to server...";
        this.connectionProgress = 50;

        await this.establishWebSocketConnection();

      } catch (error) {
        logger.error('连接过程失败:', error);
        this.isConnecting = false;
        this.fetchKey();
        this.handleConnectionError(error);
      }
    },

    async cleanupPreviousConnection() {
      // 清理WebSocket（总是执行）
      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
      // 清理定时器（总是执行）
      if (this.connectionTimer) {
        clearTimeout(this.connectionTimer);
        this.connectionTimer = null;
      }
    },

    // 建立WebSocket连接 - 优化版本
    establishWebSocketConnection() {
      return new Promise((resolve, reject) => {
        const socketUrl = `wss://${this.zhandianurl}/ws/v1?token=${this.realtimetoken}`;
        logger.log('[连接] 开始建立WebSocket连接:' + new Date().getTime(), socketUrl);
        // 使用配置的超时时间
        const connectionTimeout = setTimeout(() => {
          if (this.websocket) {
            this.websocket.close();
          }
          reject(new Error('Connection timeout after 30 seconds'));
        }, this.CONFIG.WEBSOCKET.CONNECTION_TIMEOUT);
        this.websocket = new WebSocket(socketUrl);
        let isConnectionEstablished = false;

        // 重要：在连接打开之前就设置所有事件处理器

        // 消息处理 - 提前设置
        this.websocket.onmessage = (event) => {
          try {
            // 更新最后活跃时间
            this.lastActiveTime = Date.now();
            this.connectionQuality.lastHeartbeatTime = Date.now();
            const message = JSON.parse(event.data);
            if (message.header.name === "TranscriptionStarted") {
              logger.log('[连接] 收到TranscriptionStarted确认' + new Date().getTime());
              this.isConnected = true;
              this.isConnecting = false;
            } else if (message.header.name === "TranscriptionResultChanged") {
              this.updateStreamTextOptimized(message.payload.result, this.formattedTime);
            } else if (message.header.name === "SentenceEnd") {
              this.handleSentenceEnd(message);
            } else if (message.header.name === "TranscriptionStopped") {
              logger.log('[停止转录] 收到TranscriptionStopped确认');
              this.handleTranscriptionStopped(message);
            } else {
              logger.log('[未知消息] 收到未知消息:', message);
            }
          } catch (error) {
            logger.error('处理WebSocket消息失败:', error);
            this.isConnected = false;
            this.isConnecting = false;
          }
        };

        // 错误处理 - 提前设置
        this.websocket.onerror = (event) => {
          this.isConnected = false;
          this.isConnecting = false;
          clearTimeout(connectionTimeout);
          logger.error('WebSocket 错误: ', event);
          // 增加心跳失败计数
          this.connectionQuality.heartbeatFailCount++;
          let errorMessage = 'WebSocket connection error';
          if (event.type === 'error' && !isConnectionEstablished) {
            errorMessage = 'Failed to establish WebSocket connection';
          }
          // 只有在连接建立阶段才reject
          if (!isConnectionEstablished) {
            reject(new Error(errorMessage));
          }
        };

        // 连接关闭处理 - 提前设置
        this.websocket.onclose = (event) => {
          this.isConnected = false;
          this.isConnecting = false;
          clearTimeout(connectionTimeout);
          logger.log('WebSocket连接关闭', event.code, event.reason);

          // 清理心跳定时器
          if (this.keepAliveInterval) {
            clearInterval(this.keepAliveInterval);
            this.keepAliveInterval = null;
          }

          // 处理剩余的流式文本
          this.handleWebSocketClose();

          if (!isConnectionEstablished) {
            reject(new Error(`Connection closed: ${event.reason || 'Unknown reason'}`));
          }
        };

        // 连接成功处理 - 最后设置
        this.websocket.onopen = async () => {
          clearTimeout(connectionTimeout);
          isConnectionEstablished = true;
          logger.log('WebSocket连接成功');
          // 重置连接质量指标
          this.connectionQuality.heartbeatFailCount = 0;
          this.connectionQuality.reconnectAttempts = 0;
          this.connectionQuality.lastHeartbeatTime = Date.now();

          // 重置重连状态
          if (this.scheduleReconnect_status) {
            logger.log('[连接] WebSocket连接成功，重置重连状态');
            this.scheduleReconnect_status = false;
          }

          this.connectionStatusText = "Initializing recording...";
          this.connectionProgress = 70;
          this.connectionStatusText = "Starting transcription...";
          this.connectionProgress = 90;

          // 发送开始转录消息 - 此时onmessage已经设置好了
          const startTranscriptionMessage = {
            header: {
              message_id: this.generateUUID(),
              task_id: this.generateUUID(),
              namespace: "SpeechTranscriber",
              name: "StartTranscription",
              appkey: this.appkey.value
            },
            payload: {
              format: "pcm",
              sample_rate: 16000,
              enable_intermediate_result: true,
              enable_punctuation_prediction: true,
              enable_inverse_text_normalization: true,
              max_sentence_silence: parseInt(this.maxSentenceSilence),
              enable_semantic_sentence_detection: this.isyuyiduanju
            }
          };

          if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
            this.startTranscriptiondata = startTranscriptionMessage;
            this.websocket.send(JSON.stringify(startTranscriptionMessage));
            logger.log('[连接] 发送开始转录消息' + new Date().getTime());
          }

          this.connectionStatusText = "Connected successfully!";
          this.connectionProgress = 100;
          // 启动心跳
          this.setupOptimizedKeepAlive();
          this.connectionProgress = 0;
          resolve();
        };
      });
    },

    handleConnectionError(error) {
      logger.error('[连接] 连接错误:', error);
      // 检查是否应该重试
      if (this.connectionRetryCount < this.maxConnectionRetries) {
        this.connectionRetryCount++;
        // 计算重试延迟（指数退避）
        const baseDelay = 1000;
        const delay = Math.min(baseDelay * Math.pow(2, this.connectionRetryCount - 1), 10000);
        this.connectionStatusText = `Connection failed, retrying in ${Math.ceil(delay / 1000)}s... (${this.connectionRetryCount}/${this.maxConnectionRetries})`;
        this.connectionProgress = 20;
        // 延迟重试
        this.connectionTimer = setTimeout(async () => {
          await this.startConnectionProcess();
        }, delay);
      } else {
        // 达到最大重试次数
        this.isConnecting = false;
        this.connectionProgress = 0;
        this.connectionRetryCount = 0; // 重置计数器
        // 刷新token并提示用户
        this.$message.error('Connection failed. Please check your network and try again.');
        // 尝试刷新token
        this.fetchKey().then(() => {
          logger.log('[连接] Token已刷新');
        }).catch(err => {
          logger.error('[连接] Token刷新失败:', err);
        });
      }
    },
    /**
     * 优化实时文本显示，支持防抖和智能预测合并
     * @param {string} newStreamText - 新的流式文本
     * @param {string} currentTime - 当前时间戳
     */
    updateStreamTextOptimized(newStreamText, currentTime) {
      // 清除之前的定时器
      if (this.streamTextTimer) {
        clearTimeout(this.streamTextTimer);
        this.streamTextTimer = null;
      }
      // 检查是否应该与上一个完成的文本片段预测合并
      const lastTextObj = this.textobjs.length > 0 ? this.textobjs[this.textobjs.length - 1] : null;
      this.shouldPreviewMerge = lastTextObj &&
        this.method2_ManualUTF8(lastTextObj.text) < this.CONFIG.TEXT_FRAGMENT.MIN_LENGTH &&
        (!lastTextObj.merged_count || lastTextObj.merged_count < this.CONFIG.TEXT_FRAGMENT.MAX_MERGE_COUNT);

      // 立即更新流式显示（为了实时性）
      this.streamobj.stream_text = newStreamText;
      if (!this.streamobj.stream_time) {
        this.streamobj.stream_time = currentTime || this.formattedTime;
      }
      this.streamobj.stream_trans = '';

      // logger.log('shouldPreviewMerge:', this.shouldPreviewMerge, lastTextObj);
      // 如果可能会合并，显示预览效果
      if (this.shouldPreviewMerge && lastTextObj) {
        // 为上一个文本片段添加预览样式标记（但不修改实际数据）
        this.$set(lastTextObj, 'preview_merge', true);
        this.$set(lastTextObj, 'preview_text', lastTextObj.text + this.CONFIG.TEXT_FRAGMENT.MERGE_SEPARATOR + newStreamText);
      }
    },
    /**
     * 清理流式文本预览状态
     */
    clearStreamTextPreview() {
      const lastTextObj = this.textobjs.length > 0 ? this.textobjs[this.textobjs.length - 1] : null;
      if (lastTextObj && lastTextObj.preview_merge) {
        this.$set(lastTextObj, 'preview_merge', false);
        this.$set(lastTextObj, 'preview_text', '');
      }
    },

    /**
     * 计算字符串的UTF-8字节长度
     * @param {string} str - 要计算的字符串
     * @returns {number} UTF-8字节长度
     */
    method2_ManualUTF8(str) {
      let bytes = 0;
      for (let i = 0; i < str.length; i++) {
        const codePoint = str.codePointAt(i);
        if (codePoint <= 0x7F) {
          bytes += 1;
        } else if (codePoint <= 0x7FF) {
          bytes += 2;
        } else if (codePoint <= 0xFFFF) {
          bytes += 3;
        } else {
          bytes += 4;
          i++; // surrogate pair
        }
      }
      return bytes;
    },

    handleSentenceEnd(message) {
      const newText = message.payload.result;
      const newTextLength = this.method2_ManualUTF8(newText);
      logger.log(`[文本处理] 收到新句子: "${newText}" (长度: ${newTextLength})`);
      // 检查是否有上一个文本片段，且该片段长度不足最小要求
      const lastTextObj = this.textobjs.length > 0 ? this.textobjs[this.textobjs.length - 1] : null;
      const shouldMergeWithPrevious = lastTextObj &&
        this.method2_ManualUTF8(lastTextObj.text) < this.CONFIG.TEXT_FRAGMENT.MIN_LENGTH &&
        (!lastTextObj.merged_count || lastTextObj.merged_count < this.CONFIG.TEXT_FRAGMENT.MAX_MERGE_COUNT);
      logger.log('shouldMergeWithPrevious:', shouldMergeWithPrevious);
      if (shouldMergeWithPrevious) {
        logger.log(`[文本处理] 合并到上一个片段: "${lastTextObj.text}" + "${newText}"`);
        // 合并到上一个片段
        lastTextObj.text += this.CONFIG.TEXT_FRAGMENT.MERGE_SEPARATOR + newText;
        lastTextObj.merged_count = (lastTextObj.merged_count || 1) + 1;
        lastTextObj.merged_text_ids = lastTextObj.merged_text_ids || [lastTextObj.text_id];
        lastTextObj.merged_text_ids.push(this.generateUUID8());
        // 修复：不更新时间戳，保持原有的开始时间
        // 如果原本没有时间且有流式时间，才设置时间
        if (!lastTextObj.time) {
          lastTextObj.time = this.streamobj.stream_time || this.formattedTime;
        }
        // 触发响应式更新
        this.$set(this.textobjs, this.textobjs.length - 1, { ...lastTextObj });

        // 更新partobj
        this.partobj.text = this.partobj.text + newText;
        if (!this.partobj.time) {
          this.partobj.time = lastTextObj.time;
        }
        if (lastTextObj.merged_text_ids) {
          this.partobj.text_ids.push(...lastTextObj.merged_text_ids.slice(-1)); // 只添加新的ID
        }

        // 满足合并完成的长度和次数
        if (this.method2_ManualUTF8(lastTextObj.text) > this.CONFIG.TEXT_FRAGMENT.MIN_LENGTH || lastTextObj.merged_count >= this.CONFIG.TEXT_FRAGMENT.MAX_MERGE_COUNT) {
          logger.log(`[文本处理] 段落完成，长度: ${this.method2_ManualUTF8(lastTextObj.text)}, 合并次数: ${lastTextObj.merged_count}`, lastTextObj);
          if (this.enableTranslation && this.selectedLanguage && !this.translation_text_ids.includes(lastTextObj.text_id)) {
            this.fetchTranslation(lastTextObj);
            this.translation_text_ids.push(lastTextObj.text_id);
          }
        }

        logger.log(`[文本处理] 合并完成，新长度: ${this.method2_ManualUTF8(lastTextObj.text)}, 合并次数: ${lastTextObj.merged_count}`);

      } else {
        logger.log(`[文本处理] 创建新的文本片段`);
        // 创建新的文本片段
        const textid = this.generateUUID8();
        const pushmsg = {
          time: this.streamobj.stream_time,
          text: newText,
          trans: this.streamobj.stream_trans,
          text_id: textid,
          merged_count: 1, // 初始合并次数为1
          merged_text_ids: [textid] // 包含的文本ID数组
        };
        this.textobjs.push(pushmsg);

        const lastTextObj = this.textobjs.length > 0 ? this.textobjs[this.textobjs.length - 1] : null;
        if (this.method2_ManualUTF8(lastTextObj.text) > this.CONFIG.TEXT_FRAGMENT.MIN_LENGTH) {
          logger.log(`[文本处理] 新片段长度: ${this.method2_ManualUTF8(newText)}, 满足最小长度`, pushmsg);
          if (this.enableTranslation && this.selectedLanguage && !this.translation_text_ids.includes(textid)) {
            this.fetchTranslation(lastTextObj);
            this.translation_text_ids.push(textid);
          }
        }

        // 更新partobj
        this.partobj.text = this.partobj.text + newText;
        this.partobj.text_ids.push(textid);
        if (this.partobj.time == '') {
          this.partobj.time = pushmsg.time;
        }
        if (this.partobj.partobj_id == '') {
          this.partobj.partobj_id = this.generateUUID8();
        }
      }

      // 清空流式对象
      this.streamobj = { stream_time: "", stream_text: "", stream_trans: "" };

      // 检查是否需要创建新的笔记段落
      if ((this.method2_ManualUTF8(this.partobj.text) > 500 || this.elapsedTime - this.partobj.timelength > 70) && !this.shouldPreviewMerge) {
        const currentIndex = this.partobjs.length;
        this.addNoteTask(this.partobj, currentIndex, '实时分段处理');

        this.partobj = {
          text: "",
          time: "",
          trans: "",
          notes: "",
          text_ids: [],
          partobj_id: "",
          timelength: this.elapsedTime,
        };
      }

      logger.log(`[文本处理] 当前文本片段总数: ${this.textobjs.length}, 当前段落长度: ${this.method2_ManualUTF8(this.partobj.text)}`);
    },

    handleWebSocketClose() {
      // 处理流式文本
      if (this.streamobj.stream_text) {
        logger.log(`[连接断开] 处理剩余流式文本: "${this.streamobj.stream_text}"`);
        const streamText = this.streamobj.stream_text;
        // 检查是否应该与上一个文本片段合并
        const lastTextObj = this.textobjs.length > 0 ? this.textobjs[this.textobjs.length - 1] : null;
        const shouldMergeWithPrevious = lastTextObj &&
          this.method2_ManualUTF8(lastTextObj.text) < this.CONFIG.TEXT_FRAGMENT.MIN_LENGTH &&
          (!lastTextObj.merged_count || lastTextObj.merged_count < this.CONFIG.TEXT_FRAGMENT.MAX_MERGE_COUNT);
        if (shouldMergeWithPrevious) {
          logger.log(`[连接断开] 合并流式文本到上一个片段`);
          // 合并到上一个片段
          lastTextObj.text += this.CONFIG.TEXT_FRAGMENT.MERGE_SEPARATOR + streamText;
          lastTextObj.merged_count = (lastTextObj.merged_count || 1) + 1;
          lastTextObj.merged_text_ids = lastTextObj.merged_text_ids || [lastTextObj.text_id];
          lastTextObj.merged_text_ids.push(this.generateUUID8());
          // 修复：不覆盖原有时间戳，保持段落开始时间
          // 只有在原本没有时间的情况下才设置时间
          if (!lastTextObj.time) {
            lastTextObj.time = this.streamobj.stream_time || this.formattedTime;
          }
          // 触发响应式更新
          this.$set(this.textobjs, this.textobjs.length - 1, { ...lastTextObj });
          // 更新partobj
          this.partobj.text = this.partobj.text + streamText;
          if (lastTextObj.merged_text_ids) {
            this.partobj.text_ids.push(...lastTextObj.merged_text_ids.slice(-1));
          }

          if (this.enableTranslation && this.selectedLanguage && this.method2_ManualUTF8(lastTextObj.text) > 50) {
            this.fetchTranslation(lastTextObj);
            this.translation_text_ids.push(lastTextObj.text_id);
          }
        } else {
          logger.log(`[连接断开] 创建新的文本片段处理流式文本`);
          // 创建新的文本片段
          const textid = this.generateUUID8();
          const pushmsg = {
            time: this.streamobj.stream_time,
            text: streamText,
            trans: this.streamobj.stream_trans,
            text_id: textid,
            merged_count: 1,
            merged_text_ids: [textid]
          };

          logger.log('[文本处理] 创建新的文本片段:' + new Date().getTime(), pushmsg);
          // 更新partobj
          this.partobj.text = this.partobj.text + streamText;
          this.partobj.text_ids.push(textid);
          if (this.partobj.time == '') {
            this.partobj.time = pushmsg.time;
          }
          if (this.partobj.partobj_id == '') {
            this.partobj.partobj_id = this.generateUUID8();
          }
        }

        if (this.enableTranslation && this.selectedLanguage && this.method2_ManualUTF8(this.partobj.text) > 50) {
          this.fetchTranslation(this.partobj);
          this.translation_text_ids.push(...this.partobj.text_ids);
        }

        // 清空流式对象
        this.streamobj = { stream_time: "", stream_text: "", stream_trans: "" };

        // 检查是否需要生成笔记（降低阈值，因为是最后的文本）
        // 只有在不会立即停止录音的情况下才添加任务，避免与stopRecording重复
        if (this.method2_ManualUTF8(this.partobj.text) > 100 && !this.willStopRecordingSoon) {
          const currentIndex = this.partobjs.length;
          this.addNoteTask(this.partobj, currentIndex, 'WebSocket连接断开');

          this.partobj = {
            text: "",
            time: "",
            trans: "",
            notes: "",
            text_ids: [],
            partobj_id: "",
            timelength: this.elapsedTime,
          };
        }

        logger.log(`[连接断开] 流式文本处理完成`);
      }
    },
    sendSilence() {
      const silenceData = new Int16Array(2048);
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        this.websocket.send(silenceData.buffer);
      }
    },
    async finalizeRecording() {
      try {
        const chunks = await IndexedDBAudioStorage.getAllChunks();
        logger.log(`[录音] 获取数据块完成: 总块数=${chunks ? chunks.length : 0}, 预期块数=${this.chunkCounter}`);

        if (!chunks || chunks.length === 0) {
          logger.error("[录音] 没有录音数据可用");
          return;
        }

        // 统一使用webm格式，不再区分WAV格式
        const audioBlob = new Blob(chunks, { type: "audio/webm" });
        logger.log(`[录音] 创建音频Blob: 大小=${audioBlob.size}字节, 类型=audio/webm`);

        this.audioUrl = URL.createObjectURL(audioBlob);
      } catch (error) {
        logger.error("Error finalizing recording:", error);
      }
    },

    // 合并多个WAV数据块
    mergeWavChunks(chunks) {
      return new Promise((resolve, reject) => {
        try {
          logger.log(`[系统录音] 开始合并${chunks.length}个WAV数据块`);

          // 如果只有一个块，直接返回
          if (chunks.length === 1) {
            resolve(chunks[0]);
            return;
          }

          // 将所有块转换为ArrayBuffer
          Promise.all(chunks.map(chunk =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.readAsArrayBuffer(chunk);
            })
          )).then(buffers => {
            try {
              // 解析第一个WAV头部信息，获取基本信息
              const firstBuffer = buffers[0];
              const view = new DataView(firstBuffer);

              // 检查是否是有效的WAV文件
              const riff = this.readString(view, 0, 4);
              const wave = this.readString(view, 8, 4);
              if (riff !== 'RIFF' || wave !== 'WAVE') {
                throw new Error('无效的WAV文件格式');
              }

              // 读取格式信息
              let offset = 12; // 跳过RIFF和WAVE头
              while (offset < view.byteLength) {
                const chunkType = this.readString(view, offset, 4);
                const chunkSize = view.getUint32(offset + 4, true);

                if (chunkType === 'fmt ') {
                  // 获取音频参数
                  const audioFormat = view.getUint16(offset + 8, true);
                  const numChannels = view.getUint16(offset + 10, true);
                  const sampleRate = view.getUint32(offset + 12, true);
                  const byteRate = view.getUint32(offset + 16, true);
                  const blockAlign = view.getUint16(offset + 20, true);
                  const bitsPerSample = view.getUint16(offset + 22, true);

                  logger.log(`[系统录音] WAV格式信息: 通道=${numChannels}, 采样率=${sampleRate}, 位深=${bitsPerSample}`);

                  // 提取所有数据块中的纯音频数据
                  const audioDataChunks = [];
                  let totalAudioDataLength = 0;

                  for (let i = 0; i < buffers.length; i++) {
                    const buffer = buffers[i];
                    const chunkView = new DataView(buffer);
                    let chunkOffset = 12; // 跳过RIFF和WAVE头

                    while (chunkOffset < chunkView.byteLength) {
                      const type = this.readString(chunkView, chunkOffset, 4);
                      const size = chunkView.getUint32(chunkOffset + 4, true);

                      if (type === 'data') {
                        // 找到数据块，提取纯音频数据
                        const dataStart = chunkOffset + 8;
                        const audioData = buffer.slice(dataStart, dataStart + size);
                        audioDataChunks.push(audioData);
                        totalAudioDataLength += size;
                        break;
                      }

                      chunkOffset += 8 + size;
                    }
                  }

                  // 创建合并后的WAV文件
                  const resultBuffer = new ArrayBuffer(44 + totalAudioDataLength);
                  const resultView = new DataView(resultBuffer);

                  // 写入WAV头
                  this.writeString(resultView, 0, 'RIFF');
                  resultView.setUint32(4, 36 + totalAudioDataLength, true);
                  this.writeString(resultView, 8, 'WAVE');

                  // 写入fmt块
                  this.writeString(resultView, 12, 'fmt ');
                  resultView.setUint32(16, 16, true); // 格式块大小
                  resultView.setUint16(20, audioFormat, true);
                  resultView.setUint16(22, numChannels, true);
                  resultView.setUint32(24, sampleRate, true);
                  resultView.setUint32(28, byteRate, true);
                  resultView.setUint16(32, blockAlign, true);
                  resultView.setUint16(34, bitsPerSample, true);

                  // 写入data块头
                  this.writeString(resultView, 36, 'data');
                  resultView.setUint32(40, totalAudioDataLength, true);

                  // 写入合并的音频数据
                  let dataOffset = 44;
                  for (const audioData of audioDataChunks) {
                    new Uint8Array(resultBuffer).set(new Uint8Array(audioData), dataOffset);
                    dataOffset += audioData.byteLength;
                  }

                  // 创建合并后的Blob
                  const resultBlob = new Blob([resultBuffer], { type: 'audio/wav' });
                  logger.log(`[系统录音] WAV合并完成: 大小=${resultBlob.size}字节`);
                  resolve(resultBlob);
                  return;
                }

                offset += 8 + chunkSize;
              }

              throw new Error('无法找到WAV格式信息');
            } catch (innerError) {
              logger.error(`[系统录音] 处理WAV数据失败:`, innerError);
              reject(innerError);
            }
          }).catch(error => {
            logger.error(`[系统录音] 读取WAV数据失败:`, error);
            reject(error);
          });

        } catch (error) {
          logger.error(`[系统录音] 合并WAV数据失败:`, error);
          reject(error);
        }
      });
    },

    async downloadAudio(tonext = '') {
      await this.finalizeRecording();
      if (this.audioUrl) {
        const a = document.createElement("a");
        a.href = this.audioUrl;

        // 统一使用webm扩展名
        a.download = "audio_" + Date.now() + ".webm";
        a.click();
        this.outlanjie = false;
        this.recordingState = 2; // 本地保存也算作保存成功
      }

      if (tonext !== '') {
        logger.log(tonext);
      }
    },

    chooeselanguage(language, Languagename) {
      this.chooeseLanguage = language
      this.chooeseLanguageName = Languagename
      this.$emit("chooeselanguagein", this.appkey.code, this.appkey.name);
      this.$emit("chooeselanguage", language, Languagename);
    },

    async save_audio_notes() {
      try {

        if (this.partobjs.length <= 0) {
          this.$message.error('No data can be saved, please save the audio locally'); return;
        }

        // 1. 获取录音数据
        const chunks = await IndexedDBAudioStorage.getAllChunks();
        if (!chunks || chunks.length === 0) {
          this.$message.error('No audio data available to save');
          return;
        }

        // 2. 打开保存对话框
        this.outlanjie = false;
        this.uploadProgress = 1;
        this.$refs.pRecordsave.openModal();

        // 等待所有笔记任务完成
        await this.waitForAllNotesComplete();

        // 3. 准备音频文件
        const audioBlob = new Blob(chunks, { type: 'audio/webm' });
        const timestamp = Date.now();
        const fileName = `audio_${timestamp}.webm`;
        const file = new File([audioBlob], fileName, { type: 'audio/webm' });
        // 4. 上传到R2存储
        try {
          const uploadResult = await this.uploadToR2(file);
          if (!uploadResult.success) {
            throw new Error('Upload failed');
          }
          // 5. 上传成功后的处理
          this.uploadProgress = 100;
          this.$emit('upload_audio', 'record', fileName, uploadResult.fileKey, this.elapsedTime, this.textobjs, this.noteid);
          this.recordingState = 2; // 设置为保存成功状态

        } catch (uploadError) {
          logger.error('Upload error:', uploadError);
          // 显示失败弹窗
          this.$refs.saveFailedPopup.openModal();
        }

      } catch (error) {
        logger.error('Error in save_audio_notes:', error);
        this.$message.error('An error occurred while saving the audio');
      } finally {
        // 清理和重置状态
        this.uploadProgress = 100;
      }
    },

    setupPlaybackAnalyser() {
      if (!this.playaudioContext || this.playaudioContext.state === "closed") {
        this.playaudioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        this.audioSource = null;
        this.playbackAnalyser = null;
      }
      if (this.playaudioContext.state === "suspended") {
        this.playaudioContext.resume();
      }
      if (!this.playbackAnalyser) {
        this.playbackAnalyser = this.playaudioContext.createAnalyser();
        this.playbackAnalyser.fftSize = 2048;
      }
      if (!this.audioSource) {
        this.audioSource = this.playaudioContext.createMediaElementSource(
          this.$refs.audioPlayer
        );
        this.audioSource.connect(this.playbackAnalyser);
        this.playbackAnalyser.connect(this.playaudioContext.destination);
      }
      this.playbackDataArray = new Uint8Array(
        this.playbackAnalyser.frequencyBinCount
      );
    },

    drawPlaybackWaveform() {
      if (!this.playbackAnalyser) return;
      this.playbackAnalyser.getByteTimeDomainData(this.playbackDataArray);
      const canvas = this.$refs.waveformCanvas_R;
      const canvasCtx = canvas.getContext("2d");
      const width = canvas.width;
      const height = canvas.height;
      canvasCtx.fillStyle = "#15171f";
      canvasCtx.fillRect(0, 0, width, height);
      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = "#ff4444";
      canvasCtx.beginPath();
      const sliceWidth = (width * 1.0) / this.playbackDataArray.length;
      let x = 0;
      for (let i = 0; i < this.playbackDataArray.length; i++) {
        const v = this.playbackDataArray[i] / 128.0;
        const y = (v * height) / 2;
        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }
        x += sliceWidth;
      }
      canvasCtx.lineTo(width, height / 2);
      canvasCtx.stroke();
      if (this.isPlaying) {
        this.playbackAnimationFrame = requestAnimationFrame(
          this.drawPlaybackWaveform
        );
      }
    },
    drawWaveform() {
      if (!this.isRecording) {
        logger.log('drawWaveform[录音] 停止录音', this.isRecording);
        return;
      }
      // 检查DOM元素是否存在
      if (!this.$refs.waveformCanvas || !this.analyser || !this.dataArray) {
        logger.log('drawWaveform[录音] 停止录音', this.isRecording);
        return;
      }

      this.analyser.getByteTimeDomainData(this.dataArray);
      this.canvasContext.fillStyle = "#15171f";
      this.canvasContext.fillRect(
        0,
        0,
        this.$refs.waveformCanvas.width,
        this.$refs.waveformCanvas.height
      );
      this.canvasContext.lineWidth = 2;
      this.canvasContext.strokeStyle = "#ff4444";
      this.canvasContext.beginPath();
      const sliceWidth =
        (this.$refs.waveformCanvas.width * 1.0) /
        this.analyser.frequencyBinCount;
      let x = 0;
      for (let i = 0; i < this.analyser.frequencyBinCount; i++) {
        const v = this.dataArray[i] / 128.0;
        const y = (v * this.$refs.waveformCanvas.height) / 2;
        if (i === 0) {
          this.canvasContext.moveTo(x, y);
        } else {
          this.canvasContext.lineTo(x, y);
        }
        x += sliceWidth;
      }
      this.canvasContext.lineTo(
        this.$refs.waveformCanvas.width,
        this.$refs.waveformCanvas.height / 2
      );
      this.canvasContext.stroke();
      this.animationFrame = requestAnimationFrame(this.drawWaveform);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const element = this.$refs.alltextbox;
        element.scrollTop = element.scrollHeight;
        this.autoScroll = true; // 恢复自动滚动
      });
    },

    saveaudio() {

      this.outlanjie = false;
      this.$cookies.set('ischilddeep', '')
      // if (this.radiostatus == 'startradio') {
      //     this.stopRecording();
      // }
      if (this.radiostatus == 'stopradio' || (this.radiostatus == 'startradio' && !this.isRecording)) {
        this.downloadAudio();
      }
      this.$refs.leaveSave.closeModal();
    },

    cancelSave(tonext) {
      logger.log('cansel save', tonext);
      // this.$cookies.set('ischilddeep', '')
      this.outlanjie = false;
      this.$refs.leaveSave.closeModal();
    },

    openvipchaoxian() {
      this.$emit('openvipchaoxian')
    },
    // 处理重试上传
    async handleRetryUpload() {
      await this.save_audio_notes();
    },

    // 处理关闭弹窗
    handleCloseFailedPopup() {
      // 可以在这里添加关闭后的其他操作
      // this.downloadAudio(); // 默认保存到本地
      this.$refs.pRecordsave.closeModal();
    },
    // 初始化定时器
    initTaskTimers() {
      // 每3秒处理一次队列
      this.queueTimer = setInterval(this.processNoteQueue, 3000);
      // 每30秒重试失败任务
      this.retryTimer = setInterval(this.retryFailedTasks, 10000);
    },

    // 添加任务到队列
    addNoteTask(partObj, index, source = 'unknown') {
      logger.log(`[笔记任务] 来源: ${source}, ID: ${partObj.partobj_id}, 文本长度: ${this.method2_ManualUTF8(partObj.text)}`);

      // 检查是否为空文本
      if (!partObj.text || this.method2_ManualUTF8(partObj.text) < 10) {
        logger.log(`[笔记任务] 文本内容不足，跳过: ${partObj.partobj_id}`);
        return false;
      }

      // 防止短时间内重复添加同一个partobj
      if (this.lastAddedPartObjId === partObj.partobj_id &&
        Date.now() - this.lastAddTaskTime < 5000) {
        logger.log(`[笔记任务] 5秒内重复添加，跳过: ${partObj.partobj_id}`);
        return false;
      }

      // 如果partobjs中不存在partobj_id，则添加
      if (!this.partobjs.find(p => p.partobj_id === partObj.partobj_id)) {
        this.partobjs.push(partObj);
      }

      const task = {
        id: partObj.partobj_id,
        partObj: JSON.parse(JSON.stringify(partObj)), // 深拷贝
        index: index, // 保存在partobjs中的位置
        retryCount: 0,
        timestamp: Date.now(),
        source: source // 添加来源标记
      };

      // 如果任务已经存在，则不添加
      if (this.noteTaskQueue.find(t => t.id === task.id)) {
        logger.log(`[笔记任务] 任务已存在，跳过: ${task.id}`);
        return false;
      }

      this.noteTaskQueue.push(task);
      this.lastAddedPartObjId = partObj.partobj_id;
      this.lastAddTaskTime = Date.now();

      logger.log(`[笔记任务] 任务已添加到队列: ${task.id}, 队列长度: ${this.noteTaskQueue.length}`);
      return true;
    },
    // 处理任务队列
    async processNoteQueue() {
      if (this.isProcessingQueue || this.noteTaskQueue.length === 0) return;

      this.isProcessingQueue = true;
      const task = this.noteTaskQueue[0];

      try {
        const result = await this.processNoteTask(task);
        if (result) {
          // 更新partobjs中对应位置的笔记
          this.updatePartObjsNote(task.index, task.partObj.partobj_id, result);
        }
        this.noteTaskQueue.shift();
      } catch (error) {
        logger.error('Failed to process note task:', error);
        const failedTask = this.noteTaskQueue.shift();
        if (failedTask.retryCount < 3) { // 最多重试3次
          failedTask.retryCount++;
          this.failedTasks.push(failedTask);
        }
      } finally {
        this.isProcessingQueue = false;
      }
    },

    // 处理单个笔记任务
    async processNoteTask(task) {
      const subid = this.$cookies.get("subid", "");
      let notelanguage = this.languagesItem.name;
      if (this.languagesItem?.code == 'ZH') notelanguage = 'Chinese';
      if (this.languagesItem?.code == 'ZH(T)') notelanguage = 'Traditional Chinese (Hong Kong)';

      const res = await this.$axios.post('/api/create_partnote/', {
        part_obj: JSON.stringify(task.partObj),
        text_objs: JSON.stringify(this.textobjs),
        noteid: this.noteid,
        subid: subid,
        elapsedTime: this.elapsedTime,
        note_name: this.noteTitle,
        languagein: this.appkey.code,
        language: notelanguage,
        livealidata: JSON.stringify(this.startTranscriptiondata),
      });

      if (res.data.code === 200) {
        this.noteid = res.data.noteid;
        return this.pollNoteResult(res.data.askid);
      }
      return null;
    },

    // 轮询笔记生成结果
    async pollNoteResult(askId) {
      return new Promise((resolve, reject) => {
        let attempts = 0;
        const maxAttempts = 20; // 最多尝试20次
        const checkResult = async () => {
          try {
            const res = await this.$axios.post('/api/get_partnote/', { askid: askId });
            if (res.data.code === 200) {
              resolve(res.data.answer);
            } else if (res.data.code === 201) {
              resolve(null);
            } else if (attempts < maxAttempts) {
              attempts++;
              setTimeout(checkResult, 3000); // 每秒查询一次
            } else {
              reject(new Error('Max polling attempts reached'));
            }
          } catch (error) {
            reject(error);
          }
        };
        checkResult();
      });
    },

    // 更新partobjs中的笔记
    updatePartObjsNote(index, partObjId, noteContent) {
      // 先尝试使用保存的索引
      if (this.partobjs[index]?.partobj_id === partObjId) {
        this.$set(this.partobjs[index], 'notes', this.md.render(noteContent));
        return;
      }

      // 如果索引位置不匹配，查找正确的位置
      const correctIndex = this.partobjs.findIndex(p => p.partobj_id === partObjId);
      if (correctIndex !== -1) {
        this.$set(this.partobjs[correctIndex], 'notes', this.md.render(noteContent));
      }
    },

    // 重试失败任务
    async retryFailedTasks() {
      if (this.failedTasks.length === 0) return;

      // 按原始索引排序，确保任务按正确顺序重试
      const tasksToRetry = this.failedTasks
        .filter(task => Date.now() - task.timestamp > 10000)
        .sort((a, b) => a.index - b.index);

      for (const task of tasksToRetry) {
        task.timestamp = Date.now();
        this.noteTaskQueue.push(task);
        this.failedTasks = this.failedTasks.filter(t => t.id !== task.id);
      }
    },

    async stopRecording() {
      logger.log(`[录音] 停止${this.isSystemAudio ? '系统内' : '麦克风'}录音: 已录制${this.elapsedTime}秒, 数据块数=${this.chunkCounter}`);
      this.radiostatus = "stopradio";
      // 清除录音状态cookie标记
      this.$cookies.set('ischilddeep', '');
      // 标记即将停止录音，避免其他地方重复处理
      this.willStopRecordingSoon = true;

      // 在停止录音时先停止转录
      this.stopTranscription();

      // 处理最后一个未完成的片段
      if (this.partobj.text) {
        this.partobj.partobj_id = this.partobj.partobj_id || this.generateUUID8();
        const currentIndex = this.partobjs.length;
        this.addNoteTask(this.partobj, currentIndex, '手动停止录音');
      }

      this.pauseTime = 0;
      this.isRecording = false;
      this.isPaused = false;

      // 停止录音时关闭提示
      this.showSystemAudioTip = false;

      // 统一麦克风和系统内录音的停止逻辑
      if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }

      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }

      if (this.audioContext && this.audioContext.state !== "closed") {
        this.audioContext.close().catch(error =>
          logger.error("[录音] 关闭音频上下文错误:", error)
        );
      }

      if (this.analyser) {
        this.analyser.disconnect();
        this.analyser = null;
      }

      if (this.timer) {
        clearInterval(this.timer);
      }

      clearInterval(this.keepAliveInterval);
      cancelAnimationFrame(this.animationFrame);


      this.mediaRecorder = null;
      this.audioContext = null;
      await this.save_audio_notes();
      // 重置标记
      this.willStopRecordingSoon = false;
    },
    // 添加等待所有笔记完成的方法
    async waitForAllNotesComplete() {
      return new Promise((resolve) => {
        const checkQueue = setInterval(() => {
          if (this.noteTaskQueue.length === 0 && this.failedTasks.length === 0 && !this.isProcessingQueue) {
            clearInterval(checkQueue);
            resolve();
          }
        }, 1000);
      });
    },

    initResizer() {
      const resizer = this.$refs.resizer;
      const leftPane = this.$refs.recordlecture;
      const rightPane = this.$refs.recordtotext;
      const container = this.$el.querySelector('.recode_notesbox');

      if (!resizer || !leftPane || !rightPane || !container) {
        return;
      }

      // // 恢复保存的宽度
      // const savedWidth = localStorage.getItem('recordLectureWidth');
      // if (savedWidth) {
      //     leftPane.style.width = savedWidth;
      //     resizer.style.left = `calc(${savedWidth} + 20px)`;
      // } else {
      //     // 设置初始位置
      //     resizer.style.left = 'calc(50% + 20px)';
      // }

      let x = 0;
      let leftWidth = 0;

      const mouseDownHandler = (e) => {
        x = e.clientX;
        leftWidth = leftPane.getBoundingClientRect().width;
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
        resizer.style.transition = 'none';
      };

      const mouseMoveHandler = (e) => {
        const dx = e.clientX - x;
        const containerWidth = container.getBoundingClientRect().width;
        const minWidth = 400; // 最小宽度 200px
        const maxWidth = containerWidth - 400; // 右侧也预留最小宽度

        let newLeftWidth = leftWidth + dx;
        newLeftWidth = Math.max(minWidth, Math.min(maxWidth, newLeftWidth));

        const newLeftWidthPercent = (newLeftWidth / containerWidth) * 100;
        leftPane.style.width = `${newLeftWidthPercent}%`;

        // 更新拖动条位置
        resizer.style.left = `calc(${newLeftWidthPercent}% + 20px)`;
      };

      const mouseUpHandler = () => {
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
        resizer.style.transition = 'left 0.2s';
        localStorage.setItem('recordLectureWidth', leftPane.style.width);
      };

      resizer.addEventListener('mousedown', mouseDownHandler);

      // 添加窗口大小改变时的处理
      window.addEventListener('resize', () => {
        const containerWidth = container.getBoundingClientRect().width;
        const currentWidth = leftPane.getBoundingClientRect().width;
        const widthPercent = (currentWidth / containerWidth) * 100;
        leftPane.style.width = `${widthPercent}%`;
        resizer.style.left = `calc(${widthPercent}% + 20px)`;
      });
    },

    async handleNetworkChange() {
      // 清除之前的防抖定时器
      if (this.connectionQuality.networkChangeDebounceTimer) {
        clearTimeout(this.connectionQuality.networkChangeDebounceTimer);
      }
      // 防抖处理，避免网络状态频繁变化时的重复操作
      this.connectionQuality.networkChangeDebounceTimer = setTimeout(async () => {
        const wasOnline = this.isOnline;
        this.isOnline = navigator.onLine;
        logger.log(`[网络] 状态变化: ${wasOnline ? '在线' : '离线'} -> ${this.isOnline ? '在线' : '离线'}`);
        if (this.isOnline && !wasOnline) {
          // 网络恢复
          logger.log('[网络] 网络已恢复');
          // 只有在录音状态且未连接时才尝试重连
          if (this.radiostatus === 'startradio' && !this.isConnected && !this.isConnecting) {
            logger.log('[网络] 网络恢复，尝试重连WebSocket...');
            // 重置重连计数，给网络恢复一个新的机会
            this.connectionQuality.reconnectAttempts = 0
            try {
              await this.startConnectionProcess();
            } catch (error) {
              logger.error('[网络] 网络恢复后重连失败:', error);
            }
          }
        } else if (!this.isOnline && wasOnline) {
          // 网络断开
          logger.log('[网络] 网络已断开');
          // 断网时优雅关闭连接，不触发重连
          if (this.isConnected) {
            this.disconnectWebSocketGracefully();
          }
        }
      }, this.CONFIG.WEBSOCKET.NETWORK_CHANGE_DEBOUNCE);
    },

    // 优雅断开WebSocket连接
    disconnectWebSocketGracefully() {
      logger.log('[连接] 优雅断开WebSocket连接');
      // 在断开连接前先停止转录
      this.stopTranscription();
      this.handleSentenceEnd({ payload: { result: this.streamobj.stream_text } });
      // 清除所有定时器
      this.clearAllTimers();
      if (this.websocket) {
        try {
          // 设置关闭事件处理器为空，避免触发重连
          this.websocket.onclose = null;
          this.websocket.onerror = null;
          this.websocket.close(1000, '网络断开');
        } catch (error) {
          logger.error('[连接] 关闭WebSocket时发生错误:', error);
        }
        this.websocket = null;
      }
      this.isConnected = false;
      this.isConnecting = false;
    },

    // 清除所有定时器
    clearAllTimers() {
      const timers = [
        'reconnectTimer',
        'checkConnectionTimer',
        'connectionTimer',
        'keepAliveInterval'
      ];

      timers.forEach(timer => {
        if (this[timer]) {
          if (timer === 'keepAliveInterval') {
            clearInterval(this[timer]);
          } else {
            clearTimeout(this[timer]);
          }
          this[timer] = null;
        }
      });

      // 清除网络变化防抖定时器
      if (this.connectionQuality.networkChangeDebounceTimer) {
        clearTimeout(this.connectionQuality.networkChangeDebounceTimer);
        this.connectionQuality.networkChangeDebounceTimer = null;
      }

      // 清除录音防抖定时器
      if (this.startRecordingTimeout) {
        clearTimeout(this.startRecordingTimeout);
        this.startRecordingTimeout = null;
      }

      // 清除翻译轮询
      // this.clearTranslationPolling();

      // 重置重连状态
      if (this.scheduleReconnect_status) {
        logger.log('[定时器] 清理定时器时重置重连状态');
        this.scheduleReconnect_status = false;
        this.connectionQuality.reconnectAttempts = 0;
      }
    },

    startEditTitle() {
      this.isEditingTitle = true;
      this.$nextTick(() => {
        this.$refs.titleInput.focus();
      });
    },
    endEditTitle() {
      this.isEditingTitle = false;
    },

    generateDefaultTitle() {
      const now = new Date();
      const year = now.getFullYear().toString().substr(2); // 获取年份后两位
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 获取月份并补零
      const day = now.getDate().toString().padStart(2, '0'); // 获取日期并补零

      this.noteTitle = `Untitled_${year}${month}${day}`;
    },

    // 创建WAV格式缓冲区
    createWavBuffer(leftChannel, rightChannel, sampleRate) {
      const numChannels = 2;
      const bitsPerSample = 16;
      const dataLength = leftChannel.length;

      // 将音频数据转换为16位整数
      const interleavedData = new Int16Array(dataLength * numChannels);
      for (let i = 0; i < dataLength; i++) {
        // 左声道，确保值在 -1 到 1 之间
        interleavedData[i * 2] = Math.max(-1, Math.min(1, leftChannel[i])) * 0x7FFF;
        // 右声道，确保值在 -1 到 1 之间
        interleavedData[i * 2 + 1] = Math.max(-1, Math.min(1, rightChannel[i])) * 0x7FFF;
      }

      // 计算数据大小
      const dataSize = interleavedData.length * (bitsPerSample / 8);
      const buffer = new ArrayBuffer(44 + dataSize);
      const view = new DataView(buffer);

      // 写入WAV头
      this.writeString(view, 0, 'RIFF');
      view.setUint32(4, 36 + dataSize, true);
      this.writeString(view, 8, 'WAVE');

      // fmt子块
      this.writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true); // PCM格式
      view.setUint16(20, numChannels, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, sampleRate * numChannels * (bitsPerSample / 8), true);
      view.setUint16(32, numChannels * (bitsPerSample / 8), true);
      view.setUint16(34, bitsPerSample, true);

      // data子块
      this.writeString(view, 36, 'data');
      view.setUint32(40, dataSize, true);

      // 写入音频数据
      const uint8 = new Uint8Array(buffer, 44);
      const dataBytes = new Uint8Array(interleavedData.buffer);
      uint8.set(dataBytes);

      return buffer;
    },

    writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    },

    // 从DataView中读取字符串
    readString(view, offset, length) {
      let result = '';
      for (let i = 0; i < length; i++) {
        result += String.fromCharCode(view.getUint8(offset + i));
      }
      return result;
    },
    /**
     * 改进的setupKeepAlive方法 - 增加连接健康检查
     */
    setupKeepAlive() {
      if (this.keepAliveInterval) {
        clearInterval(this.keepAliveInterval);
      }
      this.keepAliveInterval = setInterval(() => {
        const now = Date.now();
        const timeSinceLastActive = now - this.lastActiveTime;
        // 检查连接健康状态
        if (timeSinceLastActive > this.CONFIG.KEEP_ALIVE_INTERVAL) {
          logger.log(`[心跳检查] 连接空闲时间过长 (${timeSinceLastActive}ms)，准备断开`);
          this.disconnectWebSocketGracefully();
        } else {
          // 发送心跳数据
          this.sendHeartbeat();
        }
      }, 10000); // 每10秒检查一次
    },

    /**
     * 改进的心跳发送方法
     */
    sendHeartbeat() {
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        try {
          // 发送静音数据作为心跳
          const silenceData = new Int16Array(1024); // 减小心跳数据包大小
          this.websocket.send(silenceData.buffer);

          // 更新最后活跃时间
          this.lastActiveTime = Date.now();

          logger.log('[心跳] 发送心跳数据');
        } catch (error) {
          logger.error('[心跳] 发送失败:', error);
          // 心跳发送失败，可能连接已断开
          this.handleWebSocketClose();
        }
      }
    },
    /**
     * 检查浏览器兼容性
     * 在开启在线课程模式时检查浏览器是否支持系统音频录制
     */
    checkBrowserCompatibility() {
      // 检测浏览器类型 - 只允许Chrome
      const isChrome = /chrome/i.test(navigator.userAgent) && !/edg/i.test(navigator.userAgent);
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      const isFirefox = /firefox/i.test(navigator.userAgent);

      if (!isChrome) {
        this.isBrowserIncompatible = true;

        if (isSafari) {
          this.systemAudioTipText = 'Safari browser does not support system audio recording. Please use Chrome for the best experience.';
        } else if (isFirefox) {
          this.systemAudioTipText = 'Firefox browser does not support system audio recording. Please use Chrome for the best experience.';
        } else {
          this.systemAudioTipText = 'Your current browser does not support system audio recording. Please use Chrome for the best experience.';
        }

        return false;
      }

      // 浏览器兼容，重置提示状态
      this.isBrowserIncompatible = false;
      this.systemAudioTipText = "Captures audio directly from a browser tab — ideal for online classes or web meetings.";
      return true;
    },
    // 新增：统一的系统录音结束处理方法
    async handleSystemRecordingEnd(reason = 'unknown') {
      // 防止重复处理
      if (this.isHandlingSystemRecordingEnd) {
        logger.log(`[系统录音] 正在处理录音结束，跳过重复调用: ${reason}`);
        return;
      }

      this.isHandlingSystemRecordingEnd = true;
      this.willStopRecordingSoon = true;

      try {
        logger.log(`[系统录音] ${reason}触发录音结束处理`);

        // 检查是否正在录音
        if (!this.isRecording && !this.isPaused) {
          logger.log('[系统录音] 未在录音状态，直接清理资源');
          await this.cleanupRecordingResources();
          return;
        }

        // 判断录音时长是否足够保存
        if (this.elapsedTime > 60) {
          logger.log(`[系统录音] 录音时长${this.elapsedTime}秒，执行保存流程`);
          // 先停止录音相关的资源，但保持数据
          this.radiostatus = "stopradio";
          this.isRecording = false;
          this.isPaused = false;
          // 处理最后一个未完成的片段 - 统一调用一次
          if (this.partobj.text) {
            this.partobj.partobj_id = this.partobj.partobj_id || this.generateUUID8();
            const currentIndex = this.partobjs.length;
            this.addNoteTask(this.partobj, currentIndex, `系统录音结束-${reason}`);
          }
          // 清理录音资源
          await this.cleanupRecordingResources();
          // // 执行保存逻辑
          await this.save_audio_notes();
        } else {
          logger.log(`[系统录音] 录音时长${this.elapsedTime}秒，时间太短，清除数据`);
          // 录音时间太短，清除笔记和转录数据
          this.radiostatus = "stopradio";
          this.textobjs = [];
          this.partobjs = [];
          this.streamobj = { stream_time: "", stream_text: "", stream_trans: "" };
          this.partobj = {
            text: "",
            time: "",
            trans: "",
            notes: "",
            text_ids: [],
            partobj_id: "",
            timelength: 0,
          };

          this.recordingState = 0;
          this.isRecording = false;
          this.isPaused = false;

          // 清理录音资源
          await this.cleanupRecordingResources();

          // 完成录音数据处理，准备音频文件供本地下载
          await this.finalizeRecording();
        }
      } catch (error) {
        logger.error(`[系统录音] ${reason}处理过程中发生错误:`, error);
        // 即使出错也要清理资源
        this.radiostatus = "notradio";
        this.recordingState = 0;
        this.isRecording = false;
        this.isPaused = false;
        this.outlanjie = false;

        await this.cleanupRecordingResources();

      } finally {
        // 重置处理标志
        this.isHandlingSystemRecordingEnd = false;
        this.willStopRecordingSoon = false;

        // 显示友好提示，让用户知道可以重新选择录音方式  
        if (reason === '屏幕共享停止' || reason === '音频轨道停止') {
          this.showSystemAudioTip = true;
          const stoppedTip = TipHelper.getSystemAudioTip('SCREEN_SHARE_STOPPED');
          this.systemAudioTipText = stoppedTip.message;
        }
      }
    },

    // 智能重连判断
    shouldAttemptReconnect(event) {
      // 正常关闭或用户主动停止录音时不重连
      if (event.code === 1000 || this.radiostatus === 'stopradio') {
        return false;
      }

      // 检查重连次数限制
      if (this.connectionQuality.reconnectAttempts >= this.CONFIG.WEBSOCKET.MAX_RECONNECT_ATTEMPTS) {
        logger.log('[重连] 达到最大重连次数限制');
        return false;
      }

      // 检查网络状态
      if (!navigator.onLine) {
        logger.log('[重连] 网络未连接，暂不重连');
        return false;
      }

      // 检查是否在录音状态
      if (this.radiostatus !== 'startradio' || !this.isRecording) {
        return false;
      }

      return true;
    },

    // 调度重连 - 使用指数退避策略，内部控制重连逻辑
    scheduleReconnect() {
      // 如果已经在重连过程中，直接返回，避免重复调用
      if (this.scheduleReconnect_status) {
        logger.log('[重连] 重连已在进行中，忽略重复调用');
        return;
      }

      // 检查是否应该进行重连
      if (!this.shouldAttemptReconnect({ code: 1006 })) {
        logger.log('[重连] 不满足重连条件，取消重连');
        return;
      }

      // 标记重连状态开始
      this.scheduleReconnect_status = true;
      logger.log('[重连] 开始重连流程');

      // 内部重连逻辑函数
      const attemptReconnect = async (attemptNumber = 1) => {
        // 检查是否超过最大重连次数
        if (attemptNumber > this.CONFIG.WEBSOCKET.MAX_RECONNECT_ATTEMPTS) {
          logger.log(`[重连] 达到最大重连次数 ${this.CONFIG.WEBSOCKET.MAX_RECONNECT_ATTEMPTS}，停止重连`);
          this.scheduleReconnect_status = false;
          this.isConnecting = false;
          this.connectionQuality.reconnectAttempts = 0;
          this.$message.error('Connection failed. Please check your network and restart recording.');
          return;
        }

        // 更新重连次数
        this.connectionQuality.reconnectAttempts = attemptNumber;

        // 计算指数退避延迟
        const baseDelay = this.CONFIG.WEBSOCKET.RECONNECT_BACKOFF_BASE;
        const maxDelay = this.CONFIG.WEBSOCKET.RECONNECT_BACKOFF_MAX;
        const delay = Math.min(
          baseDelay * Math.pow(2, attemptNumber - 1),
          maxDelay
        );

        logger.log(`[重连] 第 ${attemptNumber} 次重连，延迟 ${delay}ms`);
        this.connectionStatusText = `Reconnecting in ${Math.ceil(delay / 1000)}s... (${attemptNumber}/${this.CONFIG.WEBSOCKET.MAX_RECONNECT_ATTEMPTS})`;

        // 清理之前的重连定时器
        if (this.reconnectTimer) {
          clearTimeout(this.reconnectTimer);
          this.reconnectTimer = null;
        }

        // 设置重连定时器
        this.reconnectTimer = setTimeout(async () => {
          try {
            logger.log(`[重连] 开始执行第 ${attemptNumber} 次重连尝试`);

            // 检查WebSocket连接状态
            if (this.isConnected && !this.isConnecting) {
              logger.log('[重连] WebSocket已连接，重连成功');
              this.scheduleReconnect_status = false;
              this.connectionQuality.reconnectAttempts = 0;
              return;
            }

            // 尝试重新建立连接
            await this.startConnectionProcess();
            // 连接成功
            logger.log(`[重连] 第 ${attemptNumber} 次重连成功`);
          } catch (error) {
            logger.error(`[重连] 第 ${attemptNumber} 次重连失败:`, error);

            // 检查WebSocket连接状态，如果仍未连接则继续重连
            if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
              logger.log(`[重连] WebSocket连接不成功，准备第 ${attemptNumber + 1} 次重连`);
              // 递归调用下一次重连
              await attemptReconnect(attemptNumber + 1);
            } else {
              // 连接已成功
              logger.log('[重连] WebSocket连接已建立，重连流程结束');
              this.scheduleReconnect_status = false;
              this.connectionQuality.reconnectAttempts = 0;
            }
          }
        }, delay);
      };

      // 开始第一次重连尝试
      attemptReconnect(1);
    },

    // 优化的心跳机制
    setupOptimizedKeepAlive() {
      if (this.keepAliveInterval) {
        clearInterval(this.keepAliveInterval);
      }

      this.keepAliveInterval = setInterval(() => {
        if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
          return;
        }

        const now = Date.now();
        const timeSinceLastHeartbeat = now - this.connectionQuality.lastHeartbeatTime;

        // 只有在超过心跳间隔且正在录音时才发送心跳
        if (timeSinceLastHeartbeat > this.CONFIG.KEEP_ALIVE_INTERVAL && this.isRecording) {
          this.sendOptimizedHeartbeat();
        }
      }, this.CONFIG.KEEP_ALIVE_INTERVAL / 2); // 检查频率为心跳间隔的一半
    },

    // 优化的心跳发送
    sendOptimizedHeartbeat() {
      if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
        return;
      }

      try {
        // 发送小的静音数据作为心跳
        const silenceData = new Int16Array(512); // 减小数据包大小
        this.websocket.send(silenceData.buffer);

        this.connectionQuality.lastHeartbeatTime = Date.now();
        this.connectionQuality.heartbeatFailCount = 0; // 重置失败计数

        logger.log('[心跳] 发送成功');
      } catch (error) {
        logger.error('[心跳] 发送失败:', error);
        this.connectionQuality.heartbeatFailCount++;

        // 连续心跳失败达到阈值时，认为连接有问题
        if (this.connectionQuality.heartbeatFailCount >= this.CONFIG.WEBSOCKET.HEARTBEAT_FAIL_THRESHOLD) {
          logger.log('[心跳] 连续失败次数过多，可能连接异常');
          this.handleConnectionIssue();
        }
      }
    },

    // 处理连接问题
    handleConnectionIssue() {
      if (this.websocket) {
        this.websocket.close();
      }
    },

    // 清理音频资源的统一方法
    cleanupAudioResources() {
      try {
        // 清理音频处理器
        if (this.audioProcessor) {
          this.audioProcessor.disconnect();
          this.audioProcessor = null;
        }

        // 清理脚本处理器
        if (this.scriptProcessor) {
          this.scriptProcessor.disconnect();
          this.scriptProcessor = null;
        }

        // 清理音频源
        if (this.audioSource) {
          this.audioSource.disconnect();
          this.audioSource = null;
        }

        // 清理分析器
        if (this.analyser) {
          this.analyser.disconnect();
          this.analyser = null;
        }

        // 清理播放分析器
        if (this.playbackAnalyser) {
          this.playbackAnalyser.disconnect();
          this.playbackAnalyser = null;
        }

        // 关闭音频上下文
        if (this.audioContext && this.audioContext.state !== 'closed') {
          this.audioContext.close();
        }

        if (this.playaudioContext && this.playaudioContext.state !== 'closed') {
          this.playaudioContext.close();
        }

        // 停止媒体流
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }

        logger.log('[清理] 音频资源清理完成');
      } catch (error) {
        logger.error('[清理] 音频资源清理失败:', error);
      }
    },

    /**
     * 停止转录方法
     * 发送停止转录消息到WebSocket服务器
     * 
     * 使用示例：
     * 1. 手动调用：this.stopTranscription()
     * 2. 在停止录音时自动调用（已集成到stopRecording方法中）
     * 3. 在断开WebSocket连接时自动调用（已集成到disconnectWebSocketGracefully方法中）
     * 
     * 注意事项：
     * - 需要确保WebSocket连接正常且已开始转录
     * - 会自动检查连接状态和taskId的有效性
     * - 发送成功后会在控制台输出确认信息
     * - 服务器响应会通过handleTranscriptionStopped方法处理
     */
    stopTranscription() {
      // 检查WebSocket连接状态和taskId
      if (!this.isConnected || !this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
        logger.warn('[停止转录] WebSocket未连接或连接状态异常');
        return;
      }

      // 获取当前的taskId（从startTranscriptiondata中获取）
      const currentTaskId = this.startTranscriptiondata?.header?.task_id;
      if (!currentTaskId) {
        logger.warn('[停止转录] 未找到有效的task_id');
        return;
      }

      // 构建停止转录消息
      const stopMessage = {
        header: {
          appkey: this.appkey.value,
          namespace: "SpeechTranscriber",
          name: "StopTranscription",
          task_id: currentTaskId,
          message_id: this.generateUUID()
        },
        payload: {}
      };

      try {
        // 发送停止转录消息
        const jsonString = JSON.stringify(stopMessage);
        this.websocket.send(jsonString);
        logger.log('[停止转录] 已发送停止转录消息', {
          task_id: currentTaskId,
          message_id: stopMessage.header.message_id
        });
        // 可选：更新组件状态
        // this.isConnected = false;
      } catch (error) {
        logger.error('[停止转录] 发送停止转录消息失败:', error);
      }
    },
    /**
     * 处理转录停止响应消息
     * @param {Object} message - 停止转录响应消息
     */
    handleTranscriptionStopped(message) {
      logger.log('[停止转录] 收到TranscriptionStopped消息:', message);
      try {
        // 更新连接状态
        this.isConnected = false;
        // 处理剩余的流式文本（如果有的话）
        logger.log('this.streamobj.stream_text:', this.streamobj.stream_text);
        if (this.streamobj.stream_text) {
          this.handleWebSocketClose();
        }
        // 清理相关数据
        this.startTranscriptiondata = null;

        // 可以触发一些清理或后续处理
        logger.log('[停止转录] 转录已成功停止');
        // 可选：显示用户提示
        // this.$message.success('转录已停止');

      } catch (error) {
        logger.error('[停止转录] 处理TranscriptionStopped消息失败:', error);
      }
    },
    shouldShowTranslation(textobj) {
      return this.enableTranslation && ((textobj.trans && !textobj.translationError) || textobj.translating);
    },
    retryTranslation(textobj) {
      // 重试生成翻译
      if (!this.enableTranslation) {
        this.$message.error('Please enable translation first');
        return;
      }
      if (!this.selectedLanguage) {
        this.$message.error('Please select translate language');
        return;
      }
      // 例如，重新获取翻译
      this.fetchTranslation(textobj);
    },
    async fetchTranslation(text_obj) {

      logger.log('fetchTranslation:', text_obj);
      // 检查翻译开关是否启用和是否选择了翻译语言
      if (!this.enableTranslation || !this.selectedLanguage) {
        return;
      }

      let textobj = this.textobjs.find(obj => obj.text_id === text_obj.text_id);
      if (textobj.translating || textobj.trans) {
        logger.log('[翻译] 该文本已请求翻译或已有翻译结果');
        return;
      }

      textobj.translating = true;

      const subid = this.$cookies.get('subid');
      const noteText = textobj.text;

      try {
        const res = await this.$axios.post('/api/set_fix_action/', {
          language: this.selectedLanguage,
          note_text: noteText,
          subid: subid,
          action: 'fix_and_translate'
        });

        const redata = res.data;
        if (redata.code === 200) {
          const ask_id = redata.askid;
          // 关联 text_id 和 askid
          textobj.askid = ask_id;
          // 开始轮询
          this.pollTranslationResult(ask_id, textobj.text_id);
        } else {
          textobj.translating = false;
          this.$message.error(redata.messages || '翻译请求失败');
        }
      } catch (error) {
        textobj.translating = false;
        logger.error('[翻译] 翻译失败:', error);
        this.$message.error('翻译请求失败，请重试');
      }
    },
    async pollTranslationResult(ask_id, text_id) {
      // 防止重复轮询同一个askid
      if (this.translationPolling && this.translationPolling.askid === ask_id) {
        logger.log('[翻译轮询] 该任务已在轮询中');
        return;
      }

      // 清理之前的轮询
      this.clearTranslationPolling();

      this.translationPolling = {
        askid: ask_id,
        textId: text_id,
        timer: null,
        attempts: 0,
        maxAttempts: 200,
      };

      const poll = async () => {
        try {
          this.translationPolling.attempts++;

          if (this.translationPolling.attempts > this.translationPolling.maxAttempts) {
            this.handleTranslationError('翻译超时，请重试', text_id);
            return;
          }

          // 睡眠1秒 只第一次
          if (this.translationPolling.attempts <= 1) {
            await new Promise(resolve => setTimeout(resolve, 1000));
          }

          const res = await this.$axios.post('/api/get_fix_action/', {
            askid: ask_id
          });

          const redata = res.data;

          switch (redata.code) {
            case 200:
              this.handleTranslationSuccess(redata, text_id);
              break;
            case 201:
              this.handleTranslationError('翻译任务不存在', text_id);
              break;
            case 202:
              this.scheduleNextPoll(poll);
              break;
            case 203:
              this.handleTranslationError('翻译失败', text_id);
              break;
            case 11:
              this.handleTranslationError('服务器错误，请重试', text_id);
              break;
            default:
              this.handleTranslationError('未知错误', text_id);
          }
        } catch (error) {
          logger.error('[翻译轮询] 请求失败:', error);
          this.handleTranslationError('网络错误，请重试', text_id);
        }
      };

      await poll();
    },

    // 安排下次轮询
    scheduleNextPoll(pollFunction) {
      if (this.translationPolling) {
        this.translationPolling.timer = setTimeout(pollFunction, 3000); // 3秒间隔
      }
    },

    // 处理翻译成功
    handleTranslationSuccess(redata, text_id) {
      logger.log('[翻译轮询] 翻译完成:', redata);

      const textObj = this.textobjs.find(obj => obj.text_id === text_id);
      if (textObj) {
        textObj.translating = false;
        if (redata.data) {
          textObj.trans = redata.data;
        }
      }

      this.clearTranslationPolling();
    },

    // 处理翻译错误
    handleTranslationError(message, text_id) {
      logger.error('[翻译轮询] 翻译失败:', message);

      const textObj = this.textobjs.find(obj => obj.text_id === text_id);
      if (textObj) {
        textObj.translating = false;
      }

      this.$message.error(message);
      this.clearTranslationPolling();
    },

    // 清理轮询
    clearTranslationPolling() {
      if (this.translationPolling) {
        if (this.translationPolling.timer) {
          clearTimeout(this.translationPolling.timer);
        }
        this.translationPolling = null;
      }
    },
    getTranslation(textobj) {
      // 获取生成翻译
      logger.log('获取翻译:', textobj);
    },
  },

  beforeDestroy() {
    logger.log('[生命周期] 组件即将销毁，开始清理资源');
    // 清理cookie中的录音状态标记
    this.$cookies.set('ischilddeep', '');
    // 停止录音
    if (this.isRecording) {
      this.stopRecording();
    }

    // 清理所有定时器
    this.clearAllTimers();

    // 清理WebSocket连接
    if (this.websocket) {
      this.websocket.onopen = null;
      this.websocket.onmessage = null;
      this.websocket.onerror = null;
      this.websocket.onclose = null;
      this.websocket.close();
      this.websocket = null;
    }

    // 清理音频相关资源
    this.cleanupAudioResources();

    // 移除网络状态监听
    window.removeEventListener('online', this.handleNetworkChange);
    window.removeEventListener('offline', this.handleNetworkChange);

    // 清理笔记生成队列
    this.noteTaskQueue = [];
    this.failedTasks = [];

    logger.log('[生命周期] 资源清理完成');
  },
};
</script>

<style lang="less">
@import '@/assets/styles/real_radio.less';

.realtimeaudio {
  background-color: #111827;
  min-height: calc(100vh - 40px);
  color: #E5E7EB;
  padding: 20px;

  .recode_notesbox {
    display: flex;
    gap: 10px;
    padding: 0 10px;
    height: calc(100vh - 40px); // 减去padding的高度
    position: relative;

    .toscollbtn {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 35px;
      height: 35px;
      background: rgba(255, 255, 255, 0.08);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.12);
      backdrop-filter: blur(20px);
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 100;

      /* 悬停效果 */
      &:hover {
        background: rgba(255, 255, 255, 0.12);
        border-color: rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

        i {
          color: #ffffff;
          transform: translateY(1px);
        }
      }

      /* 点击效果 */
      &:active {
        transform: translateY(0px);
        background: rgba(255, 255, 255, 0.15);
      }

      i {
        font-size: 20px;
        color: rgba(255, 255, 255, 0.8);
        transition: all 0.25s ease;
      }
    }

    /* 脉冲动画关键帧 */
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 0.7;
      }

      50% {
        transform: scale(1.1);
        opacity: 0.3;
      }

      100% {
        transform: scale(1.2);
        opacity: 0;
      }
    }

    /* 悬停时的脉冲动画 */
    @keyframes pulse-hover {
      0% {
        transform: scale(1);
        opacity: 0.8;
      }

      50% {
        transform: scale(1.15);
        opacity: 0.4;
      }

      100% {
        transform: scale(1.3);
        opacity: 0;
      }
    }

    .recordlecture {
      flex: none;
      width: 590px;
      min-width: 400px;
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .recordtotext {
      flex: 1;
      min-width: 400px;
      display: flex;
      flex-direction: column;
      height: 100%;

      .titlebox {
        flex: none; // 防止标题区域被压缩
      }

      .allnotesbox {
        flex: 1;
        overflow-y: auto;
        min-height: 0; // 防止flex子元素溢出
        padding-right: 10px; // 添加右侧padding，避免内容贴边

        .notesbox {
          background-color: #1F2937;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 15px;

          &:last-child {
            margin-bottom: 0; // 最后一个元素不需要底部margin
          }

          h5 {
            color: #9CA3AF;
            font-size: 13px;
            margin-bottom: 10px;
          }

          .yuantext {
            color: #E5E7EB;
            font-size: 16px;
            line-height: 1.8;

            &.markdown-content {

              h1,
              h2,
              h3,
              h4,
              h5,
              h6 {
                color: #F3F4F6;
                margin: 10px 0;
              }

              h1 {
                font-size: 22px;
              }

              h2 {
                font-size: 20px;
              }

              h3 {
                font-size: 18px;
              }


              p {
                margin: 5px 0;
              }

              code {
                background-color: #374151;
                color: #60A5FA;
                padding: 2px 4px;
                border-radius: 4px;
              }

              pre {
                background-color: #374151;
                padding: 10px;
                border-radius: 6px;
                overflow-x: auto;
              }
            }
          }

          .loading_img_box {
            display: flex;
            align-items: center;
            gap: 10px;
            color: #9CA3AF;

            img {
              width: 20px;
              height: 20px;
            }
          }
        }

        .tipstextbox {
          text-align: center;
          color: #9CA3AF;
          font-size: 14px;
          line-height: 1.6;
          padding: 20px;
        }
      }
    }

    .resizer {
      width: 0px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      cursor: col-resize;
      user-select: none;
      z-index: 1;

      &:hover {
        border: 1px solid rgba(255, 255, 255, 0.6);
      }
    }
  }

  .title-editor {
    .title-display {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;

      h1 {
        display: flex;
        align-items: center;
        font-size: 16px;
        margin: 0;
        padding-right: 40px;

        span {
          color: #F3F4F6;
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      i.el-icon-edit {
        cursor: pointer;
        color: #9CA3AF;
        font-size: 16px;
        padding: 8px;
        transition: all 0.3s;

        &:hover {
          color: #60A5FA;
        }
      }
    }

    .title-input {
      display: flex;
      align-items: center;
      position: relative;

      input {
        width: 100%;
        background: transparent;
        border: none;
        border-bottom: 1px solid #374151;
        color: #F3F4F6;
        padding: 5px 30px 5px 0;
        font-size: 16px;
        outline: none;

        &:focus {
          border-bottom-color: #60A5FA;
        }

        &::placeholder {
          color: #9CA3AF;
        }
      }

      i.el-icon-check {
        position: absolute;
        right: 0;
        cursor: pointer;
        color: #9CA3AF;
        font-size: 16px;
        padding: 8px;
        transition: all 0.3s;

        &:hover {
          color: #60A5FA;
        }
      }
    }
  }

  .notradio {
    .record-button1 {
      background-color: #374151;
      border: 2px solid #4B5563;
      transition: all 0.3s;

      &:hover {
        background-color: #4B5563;
        transform: scale(1.05);
      }

      &.connecting {
        background-color: #1F2937;
        border-color: #60A5FA;
        cursor: not-allowed;

        .connecting-icon {
          animation: spin 1s linear infinite;
          color: #60A5FA;
        }
      }

      i {
        color: #E5E7EB;
      }
    }

    .connection-status {
      margin-top: 15px;
      padding: 12px;
      background: rgba(17, 24, 39, 0.8);
      border: 1px solid #374151;
      border-radius: 8px;
      backdrop-filter: blur(10px);

      .status-text {
        color: #E5E7EB;
        font-size: 14px;
        margin-bottom: 8px;
        text-align: center;
      }

      .status-progress {
        width: 100%;
        height: 4px;
        background-color: #374151;
        border-radius: 2px;
        overflow: hidden;

        .progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #60A5FA, #3B82F6, #60A5FA);
          background-size: 200px 100%;
          border-radius: 2px;
          transition: width 0.3s ease;
          animation: shimmer 2s infinite linear;
        }
      }
    }

    .recordin {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 8px;
      width: 100%;

      .select-group {
        margin-bottom: 0;
        display: flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        width: 100%;
        justify-content: space-between;

        label {
          color: #F9FAFB;
          font-size: 15px;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          gap: 5px;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .selecttool {

          // width:150px;
          .el-input__inner {
            background-color: #111827;
            border: 1px solid #374151;
            color: #E5E7EB;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;

            &::placeholder {
              color: #fff;
              opacity: 1;
            }

            &:hover {
              border-color: #4B5563;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
            }

            &:focus {
              border-color: #60A5FA;
              box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);
            }
          }

          .el-input.is-disabled .el-input__inner {
            background-color: #1F2937;
            border-color: #2D3748;
            color: #9CA3AF;
            opacity: 0.8;
            box-shadow: none;
          }
        }
      }

      @media (max-width: 600px) {
        flex-direction: column;
        gap: 16px;

        .select-group {
          width: 100%;
          justify-content: flex-start;

          .selecttool {
            width: 100%;
          }
        }
      }
    }
  }

  .waveform {
    background-color: #1F2937;
    border-radius: 8px;
    margin: 8px auto;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .timer {
    color: #E5E7EB;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    position: relative;

    .record-button,
    .stop-button {
      background-color: #374151;
      border: 2px solid #4B5563;
      transition: all 0.3s;

      &:hover {
        background-color: #4B5563;
        transform: scale(1.05);
      }

      i {
        color: #E5E7EB;
      }
    }

    .language-select {
      width: 120px !important;
      background: transparent !important;

      .el-input__inner {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(31, 41, 55, 0.8) 100%) !important;
        border: 1px solid rgba(75, 85, 99, 0.6) !important;
        color: #E5E7EB !important;
        border-radius: 8px !important;
        font-size: 13px !important;
        font-weight: 500 !important;
        height: 30px !important;
        line-height: 30px !important;
        padding: 0 32px 0 12px !important;
        box-shadow:
          0 2px 8px rgba(0, 0, 0, 0.15),
          inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
        backdrop-filter: blur(12px) !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        position: relative !important;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%);
          border-radius: 8px;
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }

        &::placeholder {
          color: rgba(156, 163, 175, 0.8) !important;
          font-weight: 400 !important;
        }

        &:hover {
          border-color: rgba(96, 165, 250, 0.6) !important;
          box-shadow:
            0 4px 16px rgba(0, 0, 0, 0.2),
            0 0 0 1px rgba(96, 165, 250, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.15) !important;
          transform: translateY(-1px) !important;
          background: linear-gradient(135deg, rgba(17, 24, 39, 0.95) 0%, rgba(31, 41, 55, 0.9) 100%) !important;

          &::before {
            opacity: 1;
          }
        }

        &:focus {
          border-color: #60A5FA !important;
          box-shadow:
            0 4px 20px rgba(96, 165, 250, 0.25),
            0 0 0 2px rgba(96, 165, 250, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
          transform: translateY(-1px) !important;
          background: linear-gradient(135deg, rgba(17, 24, 39, 1) 0%, rgba(31, 41, 55, 0.95) 100%) !important;

          &::before {
            opacity: 1;
          }
        }
      }

      .el-input__suffix {
        right: 8px !important;

        .el-select__caret {
          color: rgba(156, 163, 175, 0.8) !important;
          font-size: 14px !important;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

          &:hover {
            color: #60A5FA !important;
            transform: scale(1.1) !important;
          }
        }

        .el-select__caret.is-reverse {
          transform: rotateZ(180deg) scale(1.1) !important;
          color: #60A5FA !important;
        }
      }

      &:hover .el-input__suffix .el-select__caret {
        color: #60A5FA !important;
        transform: scale(1.1) !important;
      }
    }

    .download-button {
      background-color: #1F2937;
      border: 1px solid #374151;
      color: #E5E7EB;
      transition: all 0.3s;

      &:hover {
        background-color: #374151;
        border-color: #4B5563;
      }
    }
  }

  .alltextbox {
    background-color: #1F2937;
    border-radius: 8px;
    padding: 10px;
    margin-top: 10px;
    flex: 1;
    overflow-y: auto;
    min-height: 0; // 防止flex子元素溢出

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #1F2937;
    }

    &::-webkit-scrollbar-thumb {
      background: #4B5563;
      border-radius: 3px;
    }

    .textbox {
      margin-bottom: 10px;
      padding: 10px;
      background-color: #374151;
      border-radius: 6px;

      &.preview-merge {
        background-color: rgba(59, 130, 246, 0.1);
        border: 1px solid rgba(59, 130, 246, 0.3);
        transition: all 0.3s ease;

        .yuantext {
          .preview-text {
            color: #60A5FA;
            font-style: italic;
            position: relative;

            &::after {
              content: " (预览合并)";
              font-size: 12px;
              color: #9CA3AF;
              font-style: normal;
            }
          }
        }
      }

      h5 {
        color: #9CA3AF;
        font-size: 16px;
        margin-bottom: 5px;
      }

      .yuantext {
        color: #E5E7EB;
        font-size: 16px;
        line-height: 1.8;
        margin-bottom: 5px;

        .merge-count {
          font-size: 12px;
          color: #10B981;
          font-weight: 500;
          margin-left: 8px;
          opacity: 0.8;
        }

      }

      .translatetext {
        color: #9CA3AF;
        font-size: 16px;
        line-height: 1.8;
      }
    }
  }

  .extra-button {
    background-color: #374151;
    border: 1px solid #4B5563;
    color: #E5E7EB;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s;

    &:hover:not(:disabled) {
      background-color: #4B5563;
      transform: translateY(-2px);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    i {
      font-size: 14px;
    }
  }

  /* 系统内录音相关样式 */
  .record-mode-container {
    width: 100%;
    margin: 0 auto 20px;
  }

  .record-mode-card {
    background-color: #1F2937;
    border-radius: 12px;
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 20px;
  }

  .record-mode-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .record-mode-title {
    font-size: 16px;
    font-weight: 600;
    color: #E5E7EB;
  }

  .record-mode-toggle {
    display: flex;
    align-items: center;
  }

  .toggle-labels {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    span {
      font-size: 12px;
      color: #9CA3AF;
      transition: all 0.3s ease;

      &.active {
        color: #FFFFFF;
        font-weight: 600;
      }
    }
  }

  .record-mode-description {
    display: flex;
    align-items: center;
  }

  .mode-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.1));
    transition: all 0.3s ease;

    i {
      font-size: 20px;
      color: #EF4444;
    }
  }

  .mode-info {
    flex: 1;

    h3 {
      font-size: 16px;
      margin: 0 0 8px 0;
      color: #E5E7EB;
    }

    p {
      font-size: 14px;
      color: #9CA3AF;
      margin: 0;
      line-height: 1.4;
    }
  }

  /* 开关样式 */
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #374151;
    transition: .4s;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 4px;
      bottom: 4px;
      background-color: #D1D5DB;
      transition: .4s;
    }

    &.round {
      border-radius: 24px;

      &:before {
        border-radius: 50%;
      }
    }
  }

  input:checked+.slider {
    background-color: #EF4444;
  }

  input:focus+.slider {
    box-shadow: 0 0 6px rgba(239, 68, 68, 0.5);
  }

  input:checked+.slider:before {
    transform: translateX(26px);
  }

  .tip-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }

  /* 系统内录音行内提示样式 */
  .system-audio-tip-container {
    width: 100%;
    padding: 8px 0 0 0;
  }

  .system-audio-tip-inline {
    background-color: #1F2937;
    border-radius: 8px;
    padding: 10px;
    color: #D1D5DB;
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: flex-start;

    .tip-icon {
      font-size: 16px;
      color: #60A5FA;
      margin-right: 8px;
      margin-top: 2px;
    }

    .tip-content {
      flex: 1;
      text-align: left;

      p {
        font-size: 14px;
        color: #D1D5DB;
        margin: 0;
        line-height: 1.4;
      }
    }

    &.error {
      background-color: rgba(239, 68, 68, 0.1);
      border-color: rgba(239, 68, 68, 0.3);

      .tip-icon {
        color: #EF4444;
      }
    }

    &.warning {
      background-color: rgba(234, 179, 8, 0.1);
      border-color: rgba(234, 179, 8, 0.3);

      .tip-icon {
        color: #EAB308;
      }
    }
  }

  .system-audio-tip {
    width: 100%;
    background-color: #1F2937;
    border-radius: 8px;
    padding: 12px 15px;
    color: #E5E7EB;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    z-index: 1000;
    display: flex;
    align-items: flex-start;

    .tip-icon {
      font-size: 20px;
      color: #ff7b7b;
      margin-right: 12px;
      margin-top: 2px;
    }

    .tip-content {
      flex: 1;
      text-align: left;

      h3 {
        font-size: 14px;
        margin: 0 0 6px 0;
        color: #fff;
        font-weight: 600;
      }

      p {
        font-size: 14px;
        color: #D1D5DB;
        margin: 0;
        line-height: 1.5;
      }
    }

    .tip-close {
      cursor: pointer;
      font-size: 16px;
      color: #9CA3AF;
      margin-left: 8px;
      transition: color 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;

      &:hover {
        color: #fff;
      }
    }

    &.error {
      background-color: rgba(239, 68, 68, 0.1);
      border-color: rgba(239, 68, 68, 0.3);

      .tip-icon {
        color: #EF4444;
      }
    }

    &.warning {
      background-color: rgba(234, 179, 8, 0.1);
      border-color: rgba(234, 179, 8, 0.3);

      .tip-icon {
        color: #EAB308;
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }

  .browser-recommendation {
    margin-top: 10px;
    font-size: 14px;
    color: #D1D5DB;

    span {
      display: block;
      margin-bottom: 5px;
    }

    .browser-icons {
      display: flex;
      justify-content: center;
      gap: 10px;
      margin-top: 5px;

      .browser-icon {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background-color: #4B5563;
        }

        img {
          width: 24px;
          height: 24px;
        }

        span {
          font-size: 14px;
          color: #D1D5DB;
          margin: 0;
        }
      }
    }
  }

  /* 添加选择器下拉菜单样式 */
  /deep/ .el-select-dropdown {
    background-color: #1F2937;
    border: 1px solid #374151;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    margin-top: 4px;
    padding: 6px 0;

    .el-select-dropdown__item {
      color: #E5E7EB;
      font-size: 14px;
      height: 36px;
      line-height: 36px;
      padding: 0 12px;
      transition: all 0.2s ease;

      &:hover,
      &.hover {
        background-color: #374151;
      }

      &.selected {
        background-color: #2C3B52;
        color: #60A5FA;
        font-weight: 500;
        position: relative;

        &:after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 3px;
          background-color: #60A5FA;
          border-radius: 0 2px 2px 0;
        }
      }
    }

    .popper__arrow {
      border-bottom-color: #374151;

      &:after {
        border-bottom-color: #1F2937;
      }
    }

    /* 添加滚动条样式 */
    .el-scrollbar {
      .el-scrollbar__wrap {
        margin-bottom: 0 !important;
      }

      .el-scrollbar__bar {
        &.is-horizontal {
          height: 4px;
        }

        &.is-vertical {
          width: 4px;
        }

        .el-scrollbar__thumb {
          background-color: #4B5563;
          border-radius: 4px;

          &:hover {
            background-color: #60A5FA;
          }
        }
      }
    }
  }

  /* 修改选择器图标颜色 */
  /deep/ .el-select .el-input .el-select__caret {
    color: #9CA3AF;
    transition: all 0.3s;

    &:hover {
      color: #E5E7EB;
    }
  }
}

// 添加动画关键帧
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }

  100% {
    background-position: calc(200px + 100%) 0;
  }
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 重连状态样式
.reconnection-status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 8px;
  margin-bottom: 15px;

  .status-icon {
    margin-right: 12px;

    i {
      font-size: 18px;
      color: #3B82F6;
      animation: spin 1s linear infinite;
    }
  }

  .status-text {
    flex: 1;

    span {
      display: block;
      color: #3B82F6;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 6px;
    }

    .progress-bar {
      width: 100%;
      height: 4px;
      background: rgba(59, 130, 246, 0.2);
      border-radius: 2px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: linear-gradient(90deg, #3B82F6, #60A5FA);
        border-radius: 2px;
        transition: width 0.3s ease;
        background-size: 200px 100%;
        animation: shimmer 2s infinite linear;
      }
    }
  }
}

.translate-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  .translate-loading,
  .translate-error {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #9CA3AF;
    font-size: 14px;
  }

  .loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #60A5FA;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .translatetext {
    flex: 1;
  }

  .retry-btn {
    background-color: #374151;
    border: 1px solid #4B5563;
    color: #E5E7EB;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #4B5563;
      border-color: #60A5FA;
    }
  }
}

// 翻译相关样式 - 统一定义，避免重复
.translate-loading {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #60A5FA;
}

.translate-error {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #EF4444;

  .el-icon-warning {
    margin-right: 5px;
  }

  .retry-btn {
    background-color: #374151;
    border: 1px solid #4B5563;
    color: #E5E7EB;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #4B5563;
      border-color: #60A5FA;
    }
  }
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #60A5FA;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: #60A5FA;
}

.translatetext {
  color: #E5E7EB;
}

/* 翻译控制区域样式 */
.translate-control {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 15px;
}

.translate-switch-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.translate-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #374151;
    transition: .4s;
    border-radius: 24px;

    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: #9CA3AF;
      transition: .4s;
      border-radius: 50%;
    }
  }

  input:checked+.slider {
    background-color: #3B82F6;

    &:before {
      transform: translateX(26px);
      background-color: white;
    }
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #3B82F6;
  }
}

.switch-label {
  color: #E5E7EB;
  font-size: 14px;
  white-space: nowrap;
  user-select: none;
}

.language-select {
  min-width: 120px;

  &.is-disabled {
    opacity: 0.5;
  }
}

// 为Element UI的下拉框添加样式
/deep/ .language-select.is-disabled .el-input__inner {
  background-color: #374151;
  border-color: #4B5563;
  color: #6B7280;
  cursor: not-allowed;
}
</style>
